(function() {
class BundleBuilder extends HTMLElement {
constructor() {
super();
this.dealSteps = 4;
this.bundleItems = [];
this.activeCollection = '1';
this.activeIndex = 0;
this.editingUid = null;
this.currentSaving = 0;
this.currentSupplementCount = 0;
this.finalMilestoneTimer = 0;
this.chatButtonStates = new Map();
this.chatObserver = null;
this.dragState = null;
this.carouselDragProgress = 0;
this.carouselDragDirection = 0;
this.carouselInteractionLocked = false;
this.suppressCarouselClickUntil = 0;
this.suppressCarouselClickTarget = null;
this.cartRequestInFlight = false;
this.pageScrollLock = null;
this.stableViewportWidth = 0;
this.stableViewportHeight = 0;
this.viewportResizeRaf = null;
this.viewportSettleTimers = [];
this.carouselHeightKey = '';
this.carouselHeight = 0;
this.carouselHeightRaf = 0;
this.carouselTransitionTimer = 0;
this.spotlightSettleTimer = 0;
this.collectionTransitionTimer = 0;
this.collectionSwitchLocked = false;
this.drawerGesture = null;
this.drawerGestureResetTimer = 0;
this.popupGesture = null;
this.popupGestureResetTimer = 0;
this.popupGestureRaf = 0;
this.popupTransitionTimer = 0;
this.itemCountAnimationTimer = 0;
this.headerSettleTimer = 0;
this.contentOverflowRaf = 0;
this.supplementFitRaf = 0;
this.addButtonTimers = new WeakMap();
this.lastOpenTrigger = null;
this.externalOpenHandler = null;
this.externalTriggerClickHandler = null;
this.externalTriggerPointerHandler = null;
this.dominantColourCache = new Map();
this.neutralCardColour = [248, 249, 252];
this.fallbackDominantColour = [112, 118, 132];
this.rearTintStrength = 0.16;
this.rearBorderStrength = 0.34;
}
connectedCallback() {
this.fabDock = this.querySelector('.ai-bundle-fab-dock');
this.fab = this.querySelector('.ai-bundle-fab');
this.overlay = this.querySelector('.ai-bundle-overlay');
this.popup = this.querySelector('.ai-bundle-popup');
this.popupHandle = this.querySelector('.ai-bundle-popup-handle');
this.closeBtn = this.querySelector('.ai-bundle-close');
this.primaryNavBtns = Array.from(this.querySelectorAll('[data-primary-nav]'));
this.navWrap = this.querySelector('.ai-bundle-nav');
this.cards = Array.from(this.querySelectorAll('.ai-bundle-product-card'));
this.carousel = this.querySelector('.ai-bundle-carousel');
this.content = this.querySelector('.ai-bundle-content');
if (this.content) {
this.content.setAttribute('data-drawer-scrolls', '');
this.content.setAttribute('data-scroll-lock-scrollable', '');
}
this.desktopSliderControls = this.querySelector('.ai-bundle-desktop-slider-controls');
this.desktopSliderPrev = this.querySelector('[data-desktop-slider-prev]');
this.desktopSliderNext = this.querySelector('[data-desktop-slider-next]');
this.carouselActions = null;
this.mobileArrowWrap = null;
this.mobileArrowPrev = null;
this.mobileArrowNext = null;
this.sliderDots = this.querySelector('.ai-bundle-slider-dots');
this.progressBar = this.querySelector('.ai-bundle-meter__fill');
this.progressEyebrow = this.querySelector('.ai-bundle-meter__action');
this.progressTitle = this.querySelector('.ai-bundle-meter__benefit');
this.dealStepEls = Array.from(this.querySelectorAll('.ai-bundle-meter__step'));
this.progressSections = Array.from(
this.querySelectorAll('[data-bundle-meter-part]')
);
this.rewardBanner = this.querySelector('.ai-bundle-reward-banner');
this.itemCount = this.querySelector('.ai-bundle-item-count');
this.summaryTotal = this.querySelector('.ai-bundle-summary-total');
this.summaryOriginal = this.querySelector('.ai-bundle-summary-original');
this.savePill = this.querySelector('.ai-bundle-save-pill');
this.checkoutBtn = this.querySelector('.ai-bundle-checkout-btn');
this.addCartBtn = this.querySelector('.ai-bundle-footer-add-cart');
this.footer = this.querySelector('.ai-bundle-footer');

/* V128: Short, direct footer button wording. */
if (this.addCartBtn) {
const label = this.addCartBtn.querySelector(':scope > span:first-child');
if (label) label.textContent = 'ADD TO CART';
this.addCartBtn.setAttribute('aria-label', 'Add to cart');
}

if (this.checkoutBtn) {
const label = this.checkoutBtn.querySelector(':scope > span:first-child');
if (label) label.textContent = 'BUY NOW';
this.checkoutBtn.setAttribute('aria-label', 'Buy now');
}
this.summaryToggle = this.querySelector('.ai-bundle-summary-toggle');
this.summaryArrow = this.querySelector('.ai-bundle-summary-arrow');
this.summaryHint = this.querySelector('.ai-bundle-summary-hint');
this.itemWord = this.querySelector('.ai-bundle-item-word');

/* V126: Use a real footer label so old CSS pseudo-elements cannot stack. */
this.inBundleLabel = this.querySelector('.ai-bundle-in-bundle');
if (!this.inBundleLabel && this.itemWord) {
const label = document.createElement('span');
label.className = 'ai-bundle-in-bundle';
label.textContent = 'IN BUNDLE';
this.itemWord.insertAdjacentElement('afterend', label);
this.inBundleLabel = label;
}

this.drawerBackdrop = null;
this.drawer = this.querySelector('.ai-bundle-items-panel');
this.drawerClose = this.querySelector('.ai-bundle-items-panel-close');
this.drawerItems = this.querySelector('.ai-bundle-drawer-items');
this.drawerDockHost = null;
this.installThemeCartDrawerBridge();
this.ensureCardPositionIndicators();
this.initProducts();
this.bindEvents();
this.installMobileCarouselArrows();
this.renderCarousel();
this.updateSummary();
this.updateProgress();

/* Enforce a genuinely inert closed state before revealing the floating CTA. */
this.overlay.classList.remove('active', 'is-mounted');
this.popup.classList.remove(
'active',
'is-mounted',
'is-drawer-open',
'is-drawer-returning'
);
this.drawer.classList.remove('active');
this.popup.classList.remove('is-items-view');
this.popup.setAttribute('aria-hidden', 'true');
this.drawer.setAttribute('aria-hidden', 'true');
if (this.fab) this.fab.setAttribute('aria-expanded', 'false');

if (document.fonts && document.fonts.ready) {
document.fonts.ready.then(() => {
if (this.popup.classList.contains('active')) {
this.scheduleCarouselHeight(true);
}
});
}

/* The root never changes display state. It becomes visible once in a stable
   layout, then only the floating CTA fades in. */
this.classList.remove('is-ready');
this.style.removeProperty('visibility');
requestAnimationFrame(() => {
requestAnimationFrame(() => {
this.classList.add('is-ready');
});
});
}
uid() {
return 'line_' + Date.now() + '_' + Math.random().toString(36).slice(2);
}
supplementItems() {
return this.bundleItems.filter(item => item.isSupplement);
}
supplementCount() {
return this.supplementItems().reduce((sum, item) => sum + Number(item.quantity || 1), 0);
}
savingAmount() {
const count = this.supplementCount();
if (count >= 4) return 30000;
if (count === 3) return 20000;
if (count === 2) return 10000;
return 0;
}
visibleCards() {
return this.cards.filter(card => card.dataset.collection === this.activeCollection);
}
ensureCardPositionIndicators() {
this.querySelectorAll('.ai-bundle-card-position').forEach(indicator => indicator.remove());

/* V128: Ensure every Meal Care slider card has the counter element that
   renderCarousel() already updates to 1/3, 2/3, 3/3, etc. */
this.cards
.filter(card => String(card.dataset.collection || '') === '1')
.forEach(card => {
if (card.querySelector('.ai-bundle-card-counter')) return;

const counter = document.createElement('span');
counter.className = 'ai-bundle-card-counter';
counter.setAttribute('aria-hidden', 'true');
card.appendChild(counter);
});
}
isGridCollection() {
return this.activeCollection !== '1';
}
isDesktopSingleSlider() {
return this.activeCollection === '1' && this.currentViewportWidth() >= 769;
}
isTwoColumnGridCollection() {
return this.activeCollection === '2';
}
activeCollectionCountsTowardSavings() {
const card = this.cards.find(item => item.dataset.collection === this.activeCollection);
return card ? card.dataset.countsSavings === 'true' : false;
}
shouldHideProgressBar() {
if (this.activeCollection === '2') return true;
if (Number(this.activeCollection) > 2) return this.dataset.hideProgressOptional === 'true';
return false;
}
initProducts() {
this.cards.forEach(card => {
try {
const product = JSON.parse(card.dataset.productJson);
card._bundleProduct = product;
this.renderVariantChips(card, product);
const image = card.querySelector('.ai-bundle-product-image');
this.prepareCardDominantColour(card, image);
if (image && !image.complete) {
image.addEventListener('load', () => {
if (this.popup.classList.contains('active')) {
this.scheduleCarouselHeight(true);
}
}, { once: true });
}
} catch(e) {
console.error('Product JSON error', e);
}
});
}

prepareCardDominantColour(card, image) {
const fallback = this.fallbackDominantColour.slice();
this.applyRearColourVariables(card, fallback, false);

if (!image) return;
const source = image.currentSrc || image.src || image.getAttribute('src') || '';
if (!source) return;

const cacheKey = `${card.dataset.productId || 'product'}::${source}`;
let colourPromise = this.dominantColourCache.get(cacheKey);

if (!colourPromise) {
colourPromise = this.extractDominantColour(source)
.catch(() => fallback)
.then(colour => this.isUsableDominantColour(colour) ? colour : fallback);
this.dominantColourCache.set(cacheKey, colourPromise);
}

colourPromise.then(colour => {
if (!card.isConnected) return;
const detected = !colour.every((value, index) => value === fallback[index]);
this.applyRearColourVariables(card, colour, detected);
});
}

extractDominantColour(source) {
return new Promise(resolve => {
let settled = false;
const finish = colour => {
if (settled) return;
settled = true;
resolve(colour || this.fallbackDominantColour.slice());
};

const sample = new Image();
if (!/^(data:|blob:)/i.test(source)) {
sample.crossOrigin = 'anonymous';
}
sample.decoding = 'async';
sample.onload = () => {
try {
finish(this.sampleDominantColour(sample));
} catch (error) {
finish(this.fallbackDominantColour.slice());
}
};
sample.onerror = () => finish(this.fallbackDominantColour.slice());
sample.src = source;

if (sample.complete && sample.naturalWidth > 0) {
Promise.resolve().then(() => sample.onload());
}
});
}

sampleDominantColour(image) {
const size = 40;
const canvas = document.createElement('canvas');
canvas.width = size;
canvas.height = size;
const context = canvas.getContext('2d', { willReadFrequently: true });
if (!context) return this.fallbackDominantColour.slice();

context.clearRect(0, 0, size, size);
context.drawImage(image, 0, 0, size, size);
const pixels = context.getImageData(0, 0, size, size).data;
const buckets = new Map();

for (let index = 0; index < pixels.length; index += 4) {
const alpha = pixels[index + 3];
if (alpha < 96) continue;

const red = pixels[index];
const green = pixels[index + 1];
const blue = pixels[index + 2];
const maximum = Math.max(red, green, blue);
const minimum = Math.min(red, green, blue);
const chroma = maximum - minimum;
const saturation = maximum ? chroma / maximum : 0;
const luminance = (0.2126 * red) + (0.7152 * green) + (0.0722 * blue);

/* Ignore transparent canvas, near-white product backgrounds and unusably
   dark pixels while retaining warm browns and muted natural product tones. */
if (luminance > 244 && saturation < 0.14) continue;
if (luminance < 18) continue;
if (chroma < 7 && luminance > 226) continue;

const quantise = value => Math.min(255, Math.round(value / 32) * 32);
const key = `${quantise(red)},${quantise(green)},${quantise(blue)}`;
const whitePenalty = Math.max(0, (luminance - 218) / 38);
const weight = (alpha / 255) * (0.70 + (saturation * 0.80)) * (1 - (whitePenalty * 0.72));
const bucket = buckets.get(key) || { score: 0, red: 0, green: 0, blue: 0, weight: 0 };

bucket.score += weight;
bucket.red += red * weight;
bucket.green += green * weight;
bucket.blue += blue * weight;
bucket.weight += weight;
buckets.set(key, bucket);
}

let winner = null;
buckets.forEach(bucket => {
if (!winner || bucket.score > winner.score) winner = bucket;
});

if (!winner || winner.weight <= 0) return this.fallbackDominantColour.slice();
return [
Math.round(winner.red / winner.weight),
Math.round(winner.green / winner.weight),
Math.round(winner.blue / winner.weight)
];
}

isUsableDominantColour(colour) {
if (!Array.isArray(colour) || colour.length < 3) return false;
const [red, green, blue] = colour.map(value => Number(value));
if (![red, green, blue].every(Number.isFinite)) return false;
const maximum = Math.max(red, green, blue);
const minimum = Math.min(red, green, blue);
const saturation = maximum ? (maximum - minimum) / maximum : 0;
const luminance = (0.2126 * red) + (0.7152 * green) + (0.0722 * blue);
return saturation >= 0.06 && luminance >= 18 && luminance <= 244;
}

blendCardColour(base, accent, strength) {
const amount = Math.max(0, Math.min(1, Number(strength) || 0));
return base.map((value, index) => Math.round(value + ((accent[index] - value) * amount)));
}

colourString(colour) {
return `rgb(${colour.map(value => Math.max(0, Math.min(255, Math.round(value)))).join(',')})`;
}

applyRearColourVariables(card, dominant, detected = true) {
const accent = this.isUsableDominantColour(dominant)
? dominant.map(value => Math.max(0, Math.min(255, Math.round(value))))
: this.fallbackDominantColour.slice();
const surface = this.blendCardColour(this.neutralCardColour, accent, this.rearTintStrength);
const border = this.blendCardColour(this.neutralCardColour, accent, this.rearBorderStrength);

card._bundleRearColours = { accent, surface, border };
card.style.setProperty('--bb-rear-surface', this.colourString(surface));
card.style.setProperty('--bb-rear-border', this.colourString(border));
card.style.setProperty('--bb-rear-glow', `rgba(${accent.join(',')},.24)`);
card.style.setProperty('--bb-rear-glow-soft', `rgba(${accent.join(',')},.16)`);
card.dataset.rearColourReady = detected ? 'true' : 'fallback';
}

applySwipeCardColour(card, rearProgress) {
if (!card) return;
const colours = card._bundleRearColours || {
surface: this.blendCardColour(this.neutralCardColour, this.fallbackDominantColour, this.rearTintStrength),
border: this.blendCardColour(this.neutralCardColour, this.fallbackDominantColour, this.rearBorderStrength)
};
const rawProgress = Math.max(0, Math.min(1, Number(rearProgress) || 0));
/* Smoothstep keeps the product-specific rear tint attached to the physical
   card movement instead of appearing to swap at the midpoint. */
const progress = rawProgress * rawProgress * (3 - (2 * rawProgress));
const spotlightBorder = [218, 221, 238];
const surface = this.blendCardColour(this.neutralCardColour, colours.surface, progress);
const border = this.blendCardColour(spotlightBorder, colours.border, progress);
card.style.setProperty('background-color', this.colourString(surface), 'important');
card.style.setProperty('border-color', this.colourString(border), 'important');
}

lowestVariantPrice(product) {
const variants = (product && product.variants) ? product.variants.filter(v => v && v.available !== false) : [];
const pool = variants.length ? variants : ((product && product.variants) ? product.variants : []);
const prices = pool.map(v => Number(v.price || 0)).filter(price => price > 0);
return prices.length ? Math.min(...prices) : Number(product && product.price ? product.price : 0);
}
priceForOptionValue(product, optionIndex, value) {
const matches = (product.variants || []).filter(v => String(v['option' + (optionIndex + 1)]) === String(value));
const available = matches.filter(v => v.available !== false);
const pool = available.length ? available : matches;
const prices = pool.map(v => Number(v.price || 0)).filter(price => price > 0);
return prices.length ? Math.min(...prices) : 0;
}
shortFlavourLabel(value) {
return String(value || '').replace(/\s+/g, ' ').trim();
}
flavourDotClass(value) {
const text = String(value || '').toLowerCase();
if (text.includes('peanut')) return 'is-peanut';
if (text.includes('salmon')) return 'is-salmon';
if (text.includes('chicken')) return 'is-chicken';
return 'is-biltong';
}
renderVariantChips(card, product) {
const wrapper = card.querySelector('.ai-bundle-variants-wrapper');
if (!wrapper || !product.variants || !product.variants.length) return;
const firstAvailable = product.variants.find(v => v.available) || product.variants[0];
wrapper.dataset.variantId = firstAvailable.id;
if (product.variants.length === 1) {
this.resolveVariant(card, product);
return;
}
const options = product.options || [];
let html = '';
options.forEach((option, optionIndex) => {
const optionName = typeof option === 'string' ? option : (option.name || ('Option ' + (optionIndex + 1)));
const values = [...new Set(product.variants.map(v => v['option' + (optionIndex + 1)]).filter(Boolean))];
html += `<div class="ai-bundle-option-label">${this.escape(optionName)}</div>`;
html += `<div class="ai-bundle-chip-row${/flavou?r/i.test(optionName)&&values.length>=4?' is-four-flavours':''}" data-option-index="${optionIndex}">`;
values.forEach(value => {
const active = firstAvailable['option' + (optionIndex + 1)] === value ? 'active' : '';
const isSize = /size/i.test(optionName);
const isFlavour = /flavou?r/i.test(optionName);
const optionPrice = isSize ? this.priceForOptionValue(product, optionIndex, value) : 0;
const chipClass = 'ai-bundle-chip ' + active + (isSize ? ' is-size-chip' : '') + (isFlavour ? ' is-flavour-chip ' + this.flavourDotClass(value) : '');
const label = isFlavour ? this.shortFlavourLabel(value) : value;
const chipInner = isSize
? `<span class="ai-bundle-chip-main">${this.escape(value)}</span><span class="ai-bundle-chip-price">${this.money(optionPrice)}</span>`
: (isFlavour ? `<span class="ai-bundle-flavour-dot" aria-hidden="true"></span><span class="ai-bundle-chip-main">${this.escape(label)}</span>` : this.escape(value));
html += `<button type="button" class="${chipClass}" data-value="${this.escape(value)}">${chipInner}</button>`;
});
html += '</div>';
});
wrapper.innerHTML = html;
wrapper.querySelectorAll('.ai-bundle-chip').forEach(chip => {
const selectChip = () => {
if (chip.disabled) return;
const row = chip.closest('.ai-bundle-chip-row');
if (!row) return;
row.querySelectorAll('.ai-bundle-chip').forEach(c => c.classList.remove('active'));
chip.classList.add('active');
this.resolveVariant(card, product);
};

/* Select on a genuine pointer tap before the carousel's click guard runs.
   A horizontal drag does not select the variant. */
chip.addEventListener('pointerdown', event => {
chip._bundleVariantPointer = {
id: event.pointerId,
x: event.clientX,
y: event.clientY
};
/* A new physical tap is always intentional, so clear any old ghost-click guard. */
this.suppressCarouselClickUntil = 0;
this.suppressCarouselClickTarget = null;
}, { passive: true });

chip.addEventListener('pointerup', event => {
const start = chip._bundleVariantPointer;
chip._bundleVariantPointer = null;
if (!start || start.id !== event.pointerId) return;
const distance = Math.hypot(event.clientX - start.x, event.clientY - start.y);
const carouselIsSwiping = !!(this.dragState && this.dragState.lock === 'x');
if (distance > 12 || carouselIsSwiping) return;
chip._bundleVariantSelectedAt = Date.now();
selectChip();
}, { passive: true });

chip.addEventListener('pointercancel', () => {
chip._bundleVariantPointer = null;
}, { passive: true });

chip.addEventListener('click', event => {
if (chip._bundleVariantSelectedAt && Date.now() - chip._bundleVariantSelectedAt < 700) {
event.preventDefault();
event.stopPropagation();
return;
}
selectChip();
});
});
this.resolveVariant(card, product);
}
resolveVariant(card, product) {
const wrapper = card.querySelector('.ai-bundle-variants-wrapper');
if (!wrapper) return;
const selected = [];
wrapper.querySelectorAll('.ai-bundle-chip-row').forEach(row => {
const active = row.querySelector('.ai-bundle-chip.active');
selected[parseInt(row.dataset.optionIndex)] = active ? active.dataset.value : null;
});
let variant = product.variants.find(v => {
return selected.every((value, index) => !value || String(v['option' + (index + 1)]) === String(value));
});
if (!variant) variant = product.variants[0];
if (!variant) return;
wrapper.dataset.variantId = variant.id;
wrapper.dataset.variantTitle = variant.title;
wrapper.dataset.variantPrice = variant.price;
wrapper.dataset.variantAvailable = variant.available ? 'true' : 'false';
const price = card.querySelector('.ai-bundle-product-price');
if (price) {
const displayPrice = Number(variant.price || product.price || 0);
price.textContent = card.dataset.collection === '2'
? this.money(displayPrice)
: 'From ' + this.money(this.lowestVariantPrice(product));
}
this.updateCardAddControl(card);
this.scheduleCarouselHeight();
}
installMobileCarouselArrows() {
if (!this.carousel || this.mobileArrowWrap) return;

const wrap = document.createElement('div');
wrap.className = 'ai-bundle-mobile-arrows';
wrap.setAttribute('aria-hidden', 'true');

const prev = document.createElement('button');
prev.type = 'button';
prev.className = 'ai-bundle-mobile-arrow ai-bundle-mobile-arrow--prev';
prev.setAttribute('aria-label', 'Previous supplement');
prev.innerHTML = '<span aria-hidden="true">‹</span>';

const next = document.createElement('button');
next.type = 'button';
next.className = 'ai-bundle-mobile-arrow ai-bundle-mobile-arrow--next';
next.setAttribute('aria-label', 'Next supplement');
next.innerHTML = '<span aria-hidden="true">›</span>';

wrap.append(prev, next);
this.carousel.insertAdjacentElement('afterend', wrap);

this.mobileArrowWrap = wrap;
this.mobileArrowPrev = prev;
this.mobileArrowNext = next;

prev.addEventListener('click', (event) => {
event.preventDefault();
event.stopPropagation();
this.navigateMobileSlider(-1);
});

next.addEventListener('click', (event) => {
event.preventDefault();
event.stopPropagation();
this.navigateMobileSlider(1);
});

prev.addEventListener('pointerdown', event => event.stopPropagation());
next.addEventListener('pointerdown', event => event.stopPropagation());

this.updateMobileArrowVisibility();
}

navigateMobileSlider(direction) {
if (this.carouselInteractionLocked || this.collectionSwitchLocked) {
const queuedDirection = direction;
window.clearTimeout(this.mobileArrowRetryTimer);

let attempts = 0;
const retryArrowTap = () => {
attempts += 1;

if (!this.carouselInteractionLocked && !this.collectionSwitchLocked) {
this.navigateMobileSlider(queuedDirection);
return;
}

if (attempts < 5) {
this.mobileArrowRetryTimer = window.setTimeout(retryArrowTap, 70);
}
};

this.mobileArrowRetryTimer = window.setTimeout(retryArrowTap, 70);
return;
}

if (this.activeCollection !== '1') return;

const cards = this.visibleCards();
if (cards.length < 2) return;

const currentIndex = this.activeIndex;
const nextIndex =
(currentIndex + direction + cards.length) % cards.length;

if (typeof this.goToSlide === 'function') {
this.goToSlide(nextIndex);
return;
}

if (typeof this.setActiveIndex === 'function') {
this.setActiveIndex(nextIndex);
return;
}

if (typeof this.showSlide === 'function') {
this.showSlide(nextIndex);
return;
}

this.activeIndex = nextIndex;
this.renderCarousel();
}

updateMobileArrowVisibility() {
if (!this.mobileArrowWrap) return;

const cards = this.visibleCards();
const shouldShow =
this.popup &&
this.popup.classList.contains('active') &&
this.activeCollection === '1' &&
cards.length > 1 &&
this.currentViewportWidth() <= 768;

this.mobileArrowWrap.classList.toggle('is-visible', shouldShow);
this.mobileArrowWrap.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

if (this.mobileArrowPrev) this.mobileArrowPrev.tabIndex = shouldShow ? 0 : -1;
if (this.mobileArrowNext) this.mobileArrowNext.tabIndex = shouldShow ? 0 : -1;
}

bindEvents() {
if (this.fab) {
this.fab.addEventListener('click', event => {
event.preventDefault();
event.stopPropagation();
this.lastOpenTrigger = this.fab;
this.openPopup();
});
}

if (this.fabDock) {
this.fabDock.addEventListener('click', event => {
if (!event.target.closest('.ai-bundle-fab')) return;
event.preventDefault();
event.stopPropagation();
this.lastOpenTrigger = event.target.closest('.ai-bundle-fab');
this.openPopup();
});
}

/* External opening API. Either dispatch the custom event or place the
   data-open-camelus-bundle-builder attribute on any button/link. */
this.externalOpenHandler = event => {
const detail = event && event.detail ? event.detail : {};
const requestedId = detail.instanceId ? String(detail.instanceId) : '';
if (requestedId && requestedId !== String(this.dataset.instanceId || '')) return;
if (!requestedId) {
const firstBuilder = document.querySelector('bundle-builder.ai-bundle-builder');
if (firstBuilder && firstBuilder !== this) return;
}
this.lastOpenTrigger = detail.trigger instanceof Element ? detail.trigger : null;
this.openPopup();
};
document.addEventListener('camelus:open-bundle-builder', this.externalOpenHandler);

this.externalTriggerClickHandler = event => {
const trigger = event.target && event.target.closest
? event.target.closest('[data-open-camelus-bundle-builder]')
: null;
if (!trigger) return;
const requestedId = String(trigger.getAttribute('data-bundle-builder-id') || '');
if (requestedId && requestedId !== String(this.dataset.instanceId || '')) return;
if (!requestedId) {
const firstBuilder = document.querySelector('bundle-builder.ai-bundle-builder');
if (firstBuilder && firstBuilder !== this) return;
}
event.preventDefault();
this.lastOpenTrigger = trigger;
this.openPopup();
};
document.addEventListener('click', this.externalTriggerClickHandler);

this.pageReleaseHandler = () => this.unlockPageScroll();
window.addEventListener('pagehide', this.pageReleaseHandler);

this.externalTriggerPointerHandler = event => {
if (event.pointerType === 'mouse') return;

const trigger = event.target && event.target.closest
? event.target.closest('[data-open-camelus-bundle-builder]')
: null;
if (!trigger) return;

const requestedId = String(trigger.getAttribute('data-bundle-builder-id') || '');
if (requestedId && requestedId !== String(this.dataset.instanceId || '')) return;

if (!requestedId) {
const firstBuilder = document.querySelector('bundle-builder.ai-bundle-builder');
if (firstBuilder && firstBuilder !== this) return;
}

event.preventDefault();
this.lastOpenTrigger = trigger;
this.openPopup();
};
document.addEventListener('pointerup', this.externalTriggerPointerHandler, { passive:false });

const requestPopupClose = event => {
if (event) {
event.preventDefault();
event.stopPropagation();
}

if (this.popup.classList.contains('is-closing')) return;
this.closePopup();
};

this.closeBtn.addEventListener('pointerup', requestPopupClose, { passive:false });
this.closeBtn.addEventListener('touchend', requestPopupClose, { passive:false });
this.closeBtn.addEventListener('click', requestPopupClose);
this.overlay.addEventListener('click', () => {
if (this.popup.classList.contains('is-closing')) return;
this.closePopup();
});
this.primaryNavBtns.forEach(btn => {
btn.addEventListener('click', () => {
if (this.drawer.classList.contains('active')) {
this.closeDrawer({ immediate: true });
}
this.switchCollection(btn.dataset.collection);
});
});
if (this.sliderDots) {
this.sliderDots.addEventListener('click', event => {
const dot = event.target.closest('[data-slide-index]');
if (!dot || this.isGridCollection()) return;
this.goToSlide(Number(dot.dataset.slideIndex));
});
}
if (this.desktopSliderPrev) {
this.desktopSliderPrev.addEventListener('click', event => {
event.preventDefault();
event.stopPropagation();
this.moveCarousel('prev');
});
}
if (this.desktopSliderNext) {
this.desktopSliderNext.addEventListener('click', event => {
event.preventDefault();
event.stopPropagation();
this.moveCarousel('next');
});
}
this.querySelectorAll('.ai-bundle-add-btn').forEach(btn => {
const activate = () => {
if (btn.disabled) return;
const card = btn.closest('.ai-bundle-product-card');
this.addOrUpdate(card, btn);
};
btn.addEventListener('touchstart', event => {
const touch = event.touches && event.touches[0];
if (!touch) return;
btn._bundleTouchStart = { x: touch.clientX, y: touch.clientY };
}, { passive: true });
btn.addEventListener('touchend', event => {
const start = btn._bundleTouchStart;
const touch = event.changedTouches && event.changedTouches[0];
btn._bundleTouchStart = null;
if (!start || !touch) return;
if (Math.hypot(touch.clientX - start.x, touch.clientY - start.y) > 12) return;
event.preventDefault();
btn._bundleTouchAddedAt = Date.now();
activate();
}, { passive: false });
btn.addEventListener('click', event => {
if (btn._bundleTouchAddedAt && Date.now() - btn._bundleTouchAddedAt < 700) {
event.preventDefault();
return;
}
activate();
});
});
this.querySelectorAll('[data-bundle-qty]').forEach(btn => {
btn.addEventListener('click', event => {
event.preventDefault();
event.stopPropagation();
if (btn.disabled) return;
const card = btn.closest('.ai-bundle-product-card');
const delta = btn.dataset.bundleQty === 'increase' ? 1 : -1;
this.adjustCardQuantity(card, delta);
});
});
this.checkoutBtn.addEventListener('click', () => this.submitBundle('checkout', this.checkoutBtn));
if (this.addCartBtn) this.addCartBtn.addEventListener('click', () => this.submitBundle('cart', this.addCartBtn));

/* V128: The complete footer opens the selected-items view, except the two
   purchase buttons. This gives the summary area a large mobile tap target. */
if (this.footer) {
this.footer.classList.add('is-items-toggle');

this.footer.addEventListener('click', event => {
if (event.target.closest('.ai-bundle-footer-actions')) return;
this.toggleDrawer();
});
}
if (this.drawerClose) {
this.drawerClose.addEventListener('click', () => this.closeDrawer());
}
this.bindPopupGestures();
if (this.carousel) {
this.carousel.addEventListener('dragstart', event => event.preventDefault());
this.bindSpotlightCarouselGestures();
}
this.stableViewportWidth = this.currentViewportWidth();
this.stableViewportHeight = this.currentViewportHeight();
this.resizeHandler = () => {
if (this.viewportResizeRaf) cancelAnimationFrame(this.viewportResizeRaf);
if (this.contentOverflowRaf) cancelAnimationFrame(this.contentOverflowRaf);
if (this.supplementFitRaf) cancelAnimationFrame(this.supplementFitRaf);

this.viewportResizeRaf = requestAnimationFrame(() => {
const nextWidth = this.currentViewportWidth();
const nextHeight = this.currentViewportHeight();
const widthChanged = Math.abs(nextWidth - this.stableViewportWidth) > 24;
const heightChanged = Math.abs(nextHeight - this.stableViewportHeight) > 2;

/* Ignore normal storefront scrolling while the builder is closed. */
if (!this.popup.classList.contains('active')) return;

/* Safari can expand or collapse its browser bars without changing width.
   Always refresh the complete visible viewport geometry while open. */
this.captureStableViewportHeight(true);

if (this.carouselHeightRaf) cancelAnimationFrame(this.carouselHeightRaf);
clearTimeout(this.carouselTransitionTimer);

this.scheduleCarouselHeight(widthChanged || heightChanged);
this.syncContentOverflow();
});
};
window.addEventListener('resize', this.resizeHandler, { passive: true });
if (window.visualViewport) {
window.visualViewport.addEventListener('resize', this.resizeHandler, { passive: true });
window.visualViewport.addEventListener('scroll', this.resizeHandler, { passive: true });
}
this.orientationHandler = () => {
window.setTimeout(() => {
this.stableViewportWidth = this.currentViewportWidth();
if (!this.popup.classList.contains('active')) return;
this.captureStableViewportHeight(true);
this.scheduleCarouselHeight(true);
}, 160);
};
window.addEventListener('orientationchange', this.orientationHandler, { passive: true });
this.keydownHandler = event => {
if (!this.popup.classList.contains('active')) return;
const isTyping = event.target && event.target.closest &&
event.target.closest('input, textarea, select, [contenteditable="true"]');
if (!isTyping && !this.drawer.classList.contains('active') && !this.isGridCollection()) {
if (event.key === 'ArrowLeft') {
event.preventDefault();
this.moveCarousel('prev');
return;
}
if (event.key === 'ArrowRight') {
event.preventDefault();
this.moveCarousel('next');
return;
}
}
if (event.key !== 'Escape') return;
if (this.drawer.classList.contains('active')) {
this.closeDrawer();
return;
}
this.closePopup();
};
document.addEventListener('keydown', this.keydownHandler);
}


bindPopupGestures() {
/* V99: Main builder down-swipe close removed completely.
   The builder now closes only with the X button or the overlay. */
this.onPopupPointerDown = null;
this.onPopupPointerMove = null;
this.onPopupPointerEnd = null;
}

bindDrawerGestures() {
if (!this.drawer) return;

const interactiveSelector = 'button, a, input, select, textarea, [contenteditable="true"]';

this.onDrawerTouchStart = event => {
if (!this.drawer.classList.contains('active')) return;

const touch = event.touches && event.touches[0];
if (!touch) return;

const target = event.target;
const inHandleArea = Boolean(
target.closest('.ai-bundle-drawer-handle, .ai-bundle-drawer-header')
);
const scrollArea = target.closest('.ai-bundle-drawer-items');
const atScrollTop = !scrollArea || scrollArea.scrollTop <= 1;

if (!inHandleArea && (!scrollArea || !atScrollTop)) return;
if (!inHandleArea && target.closest(interactiveSelector)) return;

window.clearTimeout(this.drawerGestureResetTimer);

this.drawerGesture = {
startX: touch.clientX,
startY: touch.clientY,
lastY: touch.clientY,
lastTime: performance.now(),
startTime: performance.now(),
dragY: 0,
velocity: 0,
decided: false,
dragging: false
};
};

this.onDrawerTouchMove = event => {
const state = this.drawerGesture;
if (!state || !this.drawer.classList.contains('active')) return;

const touch = event.touches && event.touches[0];
if (!touch) return;

const dx = touch.clientX - state.startX;
const dy = touch.clientY - state.startY;
const absX = Math.abs(dx);
const absY = Math.abs(dy);

if (!state.decided) {
if (Math.max(absX, absY) < 6) return;
state.decided = true;

if (absX > absY || dy <= 0) {
this.drawerGesture = null;
return;
}
}

if (dy <= 0) return;

event.preventDefault();

const now = performance.now();
const elapsed = Math.max(1, now - state.lastTime);
const instantaneousVelocity = (touch.clientY - state.lastY) / elapsed;
state.velocity = (state.velocity * 0.68) + (instantaneousVelocity * 0.32);
state.lastY = touch.clientY;
state.lastTime = now;
state.dragging = true;

const drawerHeight = Math.max(1, this.drawer.getBoundingClientRect().height);
const resistanceStart = drawerHeight * 0.58;
const resistedY = dy > resistanceStart
? resistanceStart + ((dy - resistanceStart) * 0.38)
: dy;

state.dragY = Math.max(0, resistedY);

const progress = Math.min(1, state.dragY / Math.max(150, drawerHeight * 0.42));

this.drawer.classList.add('is-dragging');
this.drawer.style.setProperty('--drawer-drag-y', `${state.dragY.toFixed(2)}px`);

if (this.drawerBackdrop) {
this.drawerBackdrop.style.setProperty(
'--drawer-drag-progress',
progress.toFixed(4)
);
}

if (this.popup) {
const builderY = 12 * (1 - progress);
const builderScale = 0.992 + (0.008 * progress);
const builderOpacity = 0.94 + (0.06 * progress);

this.popup.style.setProperty('--drawer-builder-y', `${builderY.toFixed(2)}px`);
this.popup.style.setProperty('--drawer-builder-scale', builderScale.toFixed(4));
this.popup.style.setProperty('--drawer-builder-opacity', builderOpacity.toFixed(4));
}
};

this.onDrawerTouchEnd = () => {
const state = this.drawerGesture;
this.drawerGesture = null;
if (!state || !state.dragging) return;

const drawerHeight = Math.max(1, this.drawer.getBoundingClientRect().height);
const distanceThreshold = Math.min(120, drawerHeight * 0.18);
const shouldClose =
state.dragY >= distanceThreshold ||
state.velocity >= 0.52;

this.drawer.classList.remove('is-dragging');

if (shouldClose) {
this.closeDrawer({
fromGesture: true,
dragY: state.dragY
});
return;
}

/* Cancelled drag: settle naturally back into the open drawer position. */
this.drawer.style.setProperty('--drawer-drag-y', '0px');
if (this.drawerBackdrop) {
this.drawerBackdrop.style.setProperty('--drawer-drag-progress', '0');
}
if (this.popup) {
this.popup.style.setProperty('--drawer-builder-y', '12px');
this.popup.style.setProperty('--drawer-builder-scale', '.992');
this.popup.style.setProperty('--drawer-builder-opacity', '.94');
}

this.drawerGestureResetTimer = window.setTimeout(() => {
this.drawer.style.removeProperty('--drawer-drag-y');
if (this.drawerBackdrop) {
this.drawerBackdrop.style.removeProperty('--drawer-drag-progress');
}
if (this.popup) {
this.popup.style.removeProperty('--drawer-builder-y');
this.popup.style.removeProperty('--drawer-builder-scale');
this.popup.style.removeProperty('--drawer-builder-opacity');
}
}, 310);
};

this.drawer.addEventListener('touchstart', this.onDrawerTouchStart, { passive: true });
this.drawer.addEventListener('touchmove', this.onDrawerTouchMove, { passive: false });
this.drawer.addEventListener('touchend', this.onDrawerTouchEnd, { passive: true });
this.drawer.addEventListener('touchcancel', this.onDrawerTouchEnd, { passive: true });
}


bindSpotlightCarouselGestures() {
if (!this.carousel) return;

const interactiveSelector = 'button, a, input, select, textarea, [contenteditable="true"]';

this.carouselPointerDown = event => {
if (!this.popup.classList.contains('active')) return;
if (this.drawer.classList.contains('active')) return;
if (this.isGridCollection()) return;
if (this.isDesktopSingleSlider()) return;
if (event.pointerType === 'mouse' && event.button !== 0) return;

const cards = this.visibleCards();
const activeCard = cards[this.activeIndex];
if (!activeCard || cards.length < 2) return;

const activeRect = activeCard.getBoundingClientRect();
const dragCardWidth = Math.max(1, activeRect.width);
const dragCardHeight = Math.max(1, activeRect.height);

/* Reserve the tallest neighbouring card before the first swipe frame. This
   prevents a taller incoming product from extending beyond the settled
   carousel height and being clipped at the bottom during the gesture. */
const swipeStageHeight = cards.reduce((maximum, card) => {
const measured = Math.ceil(card.offsetHeight || card.getBoundingClientRect().height || 0);
return Math.max(maximum, measured);
}, 0);
if (swipeStageHeight > 0) {
this.carousel.style.setProperty(
'height',
`${swipeStageHeight + 56}px`,
'important'
);
this.carousel.classList.add('is-swipe-height-locked');
}

const interactiveTarget = event.target.closest(interactiveSelector);
if (interactiveTarget) {
this.suppressCarouselClickUntil = 0;
this.suppressCarouselClickTarget = null;
}

if (this.carouselInteractionLocked) return;
if (this.dragRaf) cancelAnimationFrame(this.dragRaf);
this.dragRaf = 0;

/* Dots track the finger with no transition while dragging. */
this.setSliderDotTransition(0);
this.carouselDragProgress = 0;
this.carouselDragDirection = 0;

this.dragState = {
pointerId: event.pointerId,
startX: event.clientX,
startY: event.clientY,
lastX: event.clientX,
lastTime: performance.now(),
dx: 0,
dy: 0,
velocityX: 0,
lock: null,
cards,
activeCard,
startedOnInteractive: !!interactiveTarget,
interactiveTarget,
hasCapturedPointer: false,
pendingDx: 0,
cardWidth: dragCardWidth,
cardHeight: dragCardHeight
};

/* Plain card space captures immediately. Controls remain normal taps until
   a clear horizontal gesture is detected. */
if (!this.dragState.startedOnInteractive) {
if (this.carousel.setPointerCapture) {
try {
this.carousel.setPointerCapture(event.pointerId);
this.dragState.hasCapturedPointer = true;
} catch (error) {}
}
this.carousel.classList.add('is-gesture-ready');
}
};

this.carouselPointerMove = event => {
if (!this.popup.classList.contains('active')) {
this.cancelCarouselGesture();
return;
}
const state = this.dragState;
if (!state || state.pointerId !== event.pointerId) return;

const samples = typeof event.getCoalescedEvents === 'function'
? event.getCoalescedEvents()
: null;
const sample = samples && samples.length
? samples[samples.length - 1]
: event;

const now = performance.now();
const dx = sample.clientX - state.startX;
const dy = sample.clientY - state.startY;
const dt = Math.max(1, now - state.lastTime);
const instantVelocityX = (sample.clientX - state.lastX) / dt;

/* Responsive but stable velocity sampling. */
state.velocityX = (state.velocityX * 0.58) + (instantVelocityX * 0.42);
state.lastX = sample.clientX;
state.lastTime = now;
state.dx = dx;
state.dy = dy;

if (state.lock === null) {
const horizontalStart = state.startedOnInteractive ? 8 : 4;
const horizontalBias = state.startedOnInteractive ? 4 : 1.5;

if (Math.abs(dx) > Math.abs(dy) + horizontalBias && Math.abs(dx) > horizontalStart) {
state.lock = 'x';

if (!state.hasCapturedPointer && this.carousel.setPointerCapture) {
try {
this.carousel.setPointerCapture(event.pointerId);
state.hasCapturedPointer = true;
} catch (error) {}
}

this.carousel.classList.add('is-gesture-ready', 'is-dragging');
} else if (Math.abs(dy) > Math.abs(dx) + 7 && Math.abs(dy) > 11) {
state.lock = 'y';
}
}

if (state.lock === 'y') {
this.dragState = null;
this.carousel.classList.remove('is-gesture-ready', 'is-dragging');
this.setSliderDotTransition(120);
this.updateSliderDotsProgress(0, 0);
return;
}

if (state.lock !== 'x') return;

event.preventDefault();

if (state.startedOnInteractive && Math.abs(dx) > 11) {
this.suppressCarouselClickUntil = Date.now() + 650;
this.suppressCarouselClickTarget = state.interactiveTarget || null;
}

state.pendingDx = dx;

if (!this.dragRaf) {
this.dragRaf = requestAnimationFrame(() => {
this.dragRaf = 0;
if (this.dragState) this.applySpotlightDrag(this.dragState.pendingDx);
});
}
};

this.finishCarouselPointer = event => {
const state = this.dragState;
if (!state || (event.pointerId !== undefined && state.pointerId !== event.pointerId)) return;

if (this.dragRaf) cancelAnimationFrame(this.dragRaf);
this.dragRaf = 0;

if (state.lock === 'x') this.applySpotlightDrag(state.dx);

const horizontal = state.lock === 'x';
const cardWidth = Math.max(
1,
Number(state.cardWidth) ||
state.activeCard.offsetWidth ||
1
);
const staleVelocity = performance.now() - state.lastTime > 90;
const releaseVelocity = staleVelocity ? state.velocityX * 0.45 : state.velocityX;
const movedEnough = Math.abs(state.dx) >= cardWidth * (state.startedOnInteractive ? 0.20 : 0.17);
const flicked = Math.abs(releaseVelocity) >= 0.22 &&
Math.abs(state.dx) > (state.startedOnInteractive ? 13 : 8);
const clickCancelDistance = state.startedOnInteractive ? 11 : 8;
const direction = state.dx < 0 ? 1 : -1;
const startProgress = this.carouselDragProgress;

if (horizontal && Math.abs(state.dx) > clickCancelDistance) {
this.suppressCarouselClickUntil = Date.now() + 700;
this.suppressCarouselClickTarget = state.startedOnInteractive
? (state.interactiveTarget || null)
: null;
}

this.dragState = null;
this.carousel.classList.remove('is-gesture-ready', 'is-dragging');

if (!horizontal) {
this.carousel.classList.remove('is-swipe-height-locked');
this.carousel.style.removeProperty('height');
this.setSliderDotTransition(120);
this.updateSliderDotsProgress(0, 0);
this.scheduleCarouselHeight(false);
return;
}

if (movedEnough || flicked) {
const cards = this.visibleCards();
const target = (this.activeIndex + direction + cards.length) % cards.length;

this.suppressCarouselClickUntil = Date.now() + 380;
this.suppressCarouselClickTarget = state.startedOnInteractive
? (state.interactiveTarget || null)
: null;

this.settleSpotlightTo(target, {
direction,
fromDrag: true,
releaseDx: state.dx,
releaseVelocity,
startProgress
});
} else {
this.settleSpotlightTo(this.activeIndex, {
direction,
fromDrag: true,
releaseDx: state.dx,
releaseVelocity,
startProgress
});
}
};

this.carouselClickCapture = event => {
if (Date.now() >= this.suppressCarouselClickUntil) return;

const interactive = event.target.closest(interactiveSelector);
if (
interactive &&
this.suppressCarouselClickTarget &&
interactive !== this.suppressCarouselClickTarget
) return;
if (interactive && !this.suppressCarouselClickTarget) return;

event.preventDefault();
event.stopPropagation();
};

this.carouselTouchMoveBlocker = event => {
if (!this.popup.classList.contains('active')) return;
if (this.drawer.classList.contains('active')) return;
if (this.isGridCollection()) return;
if (!this.dragState || this.dragState.lock !== 'x') return;
event.preventDefault();
};

this.carousel.addEventListener('pointerdown', this.carouselPointerDown, { passive: true });
this.carousel.addEventListener('pointermove', this.carouselPointerMove, { passive: false });
this.carousel.addEventListener('pointerup', this.finishCarouselPointer, { passive: true });
this.carousel.addEventListener('pointercancel', this.finishCarouselPointer, { passive: true });
this.carousel.addEventListener('touchmove', this.carouselTouchMoveBlocker, { passive: false });
this.carousel.addEventListener('click', this.carouselClickCapture, true);
}

applySpotlightDrag(dx) {
if (!this.popup.classList.contains('active')) return;
if (!this.carousel || this.isGridCollection()) return;

const cards = this.visibleCards();
const active = cards[this.activeIndex];
if (!active || cards.length < 2) return;

const previous = this.carousel.querySelector('.ai-bundle-product-card.prev');
const next = this.carousel.querySelector('.ai-bundle-product-card.next');
const direction = dx < 0 ? 1 : -1;
const incoming = direction === 1 ? next : previous;
const opposite = direction === 1 ? previous : next;
if (!incoming) return;

const state = this.dragState;
const cardWidth = Math.max(
1,
Number(state && state.cardWidth) ||
active.offsetWidth ||
1
);
const absDx = Math.abs(dx);

/* A flatter deck and shorter gesture range make the handoff feel fluid
   instead of stiff or spring-loaded. */
const sideScale = 0.972;
const sidePeek = Math.max(28, Math.min(34, cardWidth * 0.096));
const sideOffset = sidePeek + (cardWidth * ((1 - sideScale) / 2));
const sideDrop = 8;
const sideTilt = 0.35;

/* Finger movement maps directly to card progress. Only a very small amount
   of resistance remains after the handoff is complete. */
const gestureRange = cardWidth * 0.38;
const progress = Math.min(1, absDx / gestureRange);
const overdragDistance = Math.max(0, absDx - gestureRange);
const overdrag = Math.min(4, Math.sqrt(overdragDistance) * 0.32);

const outgoingX =
(-direction * sideOffset * progress) -
(direction * overdrag);
const outgoingY = sideDrop * progress;
const outgoingScale = 1 - ((1 - sideScale) * progress);
const outgoingRotation = -direction * sideTilt * progress;

const incomingX =
(direction * sideOffset * (1 - progress)) -
(direction * overdrag * 0.12);
const incomingY = sideDrop * (1 - progress);
const incomingScale = sideScale + ((1 - sideScale) * progress);
const incomingRotation = direction * sideTilt * (1 - progress);

/* Smoothstep prevents the image, copy and controls from popping in too early. */
const smoothstep = (start, end, value) => {
const t = Math.max(0, Math.min(1, (value - start) / (end - start)));
return t * t * (3 - (2 * t));
};

const imageReveal = smoothstep(0.05, 0.56, progress);
const textReveal = smoothstep(0.12, 0.66, progress);
const controlsReveal = smoothstep(0.18, 0.76, progress);

const outgoingImage = 1 - imageReveal;
const outgoingText = 1 - textReveal;
const outgoingControls = 1 - controlsReveal;

this.carouselDragProgress = progress;
this.carouselDragDirection = direction;
this.carousel.classList.add('is-card-handoff');
this.applySwipeCardColour(active, progress);
this.applySwipeCardColour(incoming, 1 - progress);
if (opposite && opposite !== incoming) {
this.applySwipeCardColour(opposite, 1);
}

active.style.setProperty('transition', 'none', 'important');
active.style.setProperty(
'transform',
`translate3d(-50%,0,0) translate3d(${outgoingX}px,${outgoingY}px,0) scale(${outgoingScale}) rotate(${outgoingRotation}deg)`,
'important'
);
const outgoingOpacity = Math.max(0.62, 1 - (progress * 0.34));

active.style.setProperty('opacity', outgoingOpacity.toFixed(4), 'important');
active.style.setProperty('visibility', 'visible', 'important');
active.style.setProperty('filter', 'none', 'important');
active.style.setProperty('z-index', '10', 'important');
active.style.setProperty('clip-path', 'none', 'important');
active.style.setProperty('-webkit-clip-path', 'none', 'important');
active.style.setProperty('--bb-outgoing-image', outgoingImage.toFixed(4));
active.style.setProperty('--bb-outgoing-text', outgoingText.toFixed(4));
active.style.setProperty('--bb-outgoing-controls', outgoingControls.toFixed(4));

const activeImage = active.querySelector('.ai-bundle-product-image');
if (activeImage) {
activeImage.style.setProperty('transition', 'none', 'important');
activeImage.style.setProperty(
'transform',
`translate3d(${-direction * progress * 0.7}px,0,0) scale(1)`,
'important'
);
}

incoming.style.setProperty('transition', 'none', 'important');
incoming.style.setProperty(
'transform',
`translate3d(-50%,0,0) translate3d(${incomingX}px,${incomingY}px,0) scale(${incomingScale}) rotate(${incomingRotation}deg)`,
'important'
);
const incomingOpacity = Math.min(1, 0.70 + (progress * 0.30));

incoming.style.setProperty('opacity', incomingOpacity.toFixed(4), 'important');
incoming.style.setProperty('visibility', 'visible', 'important');
incoming.style.setProperty('filter', 'none', 'important');
incoming.style.setProperty('z-index', progress > 0.52 ? '11' : '9', 'important');
incoming.style.setProperty('clip-path', 'none', 'important');
incoming.style.setProperty('-webkit-clip-path', 'none', 'important');
incoming.style.setProperty('mask-image', 'none', 'important');
incoming.style.setProperty('-webkit-mask-image', 'none', 'important');
incoming.style.setProperty('--bb-image-reveal', imageReveal.toFixed(4));
incoming.style.setProperty('--bb-text-reveal', textReveal.toFixed(4));
incoming.style.setProperty('--bb-controls-reveal', controlsReveal.toFixed(4));

const incomingImage = incoming.querySelector('.ai-bundle-product-image');
if (incomingImage) {
incomingImage.style.setProperty('transition', 'none', 'important');
incomingImage.style.setProperty(
'transform',
`translate3d(${direction * (1.2 - (progress * 1.2))}px,0,0) scale(1)`,
'important'
);
}

if (opposite && opposite !== incoming) {
const oppositeOpacity = Math.max(0.34, 1 - (progress * 0.66));
const oppositeScale = sideScale - (0.004 * progress);
const oppositeDrop = sideDrop + (0.8 * progress);
const oppositeOffset = sideOffset + (1.2 * progress);

opposite.style.setProperty('transition', 'none', 'important');
opposite.style.setProperty(
'transform',
`translate3d(-50%,0,0) translate3d(${-direction * oppositeOffset}px,${oppositeDrop}px,0) scale(${oppositeScale}) rotate(${-direction * sideTilt}deg)`,
'important'
);
opposite.style.setProperty('opacity', oppositeOpacity.toFixed(4), 'important');
opposite.style.setProperty(
'visibility',
oppositeOpacity > 0.02 ? 'visible' : 'hidden',
'important'
);
opposite.style.setProperty('filter', 'none', 'important');
opposite.style.setProperty('z-index', '4', 'important');
opposite.style.removeProperty('--bb-image-reveal');
opposite.style.removeProperty('--bb-text-reveal');
opposite.style.removeProperty('--bb-controls-reveal');
}

this.updateSliderDotsProgress(progress, direction);
}

setSliderDotTransition(duration = 0, easing = 'cubic-bezier(.18,.88,.24,1)') {
if (!this.sliderDots) return;

const dots = this.sliderDots.querySelectorAll('.ai-bundle-slider-dot');
dots.forEach(dot => {
if (duration > 0) {
dot.style.setProperty(
'transition',
`width ${duration}ms ${easing}, background-color ${duration}ms linear, opacity ${duration}ms linear`,
'important'
);
} else {
dot.style.setProperty('transition', 'none', 'important');
}
});
}

updateSliderDotsProgress(progress = 0, direction = 0) {
if (!this.sliderDots) return;

const dots = Array.from(
this.sliderDots.querySelectorAll('.ai-bundle-slider-dot')
);
if (!dots.length) return;

const p = Math.max(0, Math.min(1, Number(progress) || 0));
const activeIndex = this.activeIndex;
const targetIndex = direction
? (activeIndex + direction + dots.length) % dots.length
: -1;

this.carouselDragProgress = p;
this.carouselDragDirection = direction || 0;

dots.forEach((dot, index) => {
let width = 7;
let alpha = 0.16;

if (index === activeIndex) {
width = 26 - (19 * p);
alpha = 1 - (0.84 * p);
}

if (p > 0 && index === targetIndex) {
width = 7 + (19 * p);
alpha = 0.16 + (0.84 * p);
}

dot.style.setProperty('width', `${width.toFixed(2)}px`, 'important');
dot.style.setProperty(
'background-color',
`rgba(41,53,138,${Math.max(0.16, Math.min(1, alpha)).toFixed(3)})`,
'important'
);
dot.style.setProperty('opacity', '1', 'important');
dot.classList.toggle('is-preview-next', p > 0 && index === targetIndex);
});
}

clearSpotlightInlineStyles(removeTransition = true) {
this.cards.forEach(card => {
card.style.removeProperty('transform');
card.style.removeProperty('opacity');
card.style.removeProperty('filter');
card.style.removeProperty('box-shadow');
card.style.removeProperty('clip-path');
card.style.removeProperty('-webkit-clip-path');
card.style.removeProperty('mask-image');
card.style.removeProperty('-webkit-mask-image');
card.style.removeProperty('z-index');
card.style.removeProperty('visibility');
card.style.removeProperty('background-color');
card.style.removeProperty('border-color');
card.style.removeProperty('--spotlight-drift');
card.style.removeProperty('--bb-image-reveal');
card.style.removeProperty('--bb-text-reveal');
card.style.removeProperty('--bb-controls-reveal');
card.style.removeProperty('--bb-outgoing-image');
card.style.removeProperty('--bb-outgoing-text');
card.style.removeProperty('--bb-outgoing-controls');
if (removeTransition) card.style.removeProperty('transition');
const image = card.querySelector('.ai-bundle-product-image');
if (image) {
image.style.removeProperty('transform');
image.style.removeProperty('transition');
}
});
if (this.carousel) {
this.carousel.classList.remove('is-card-handoff');
}
this.updateSliderDotsProgress(0, 0);
}

resetSpotlightTilt() {
this.clearSpotlightInlineStyles(true);
}

settleDesktopSliderTo(index, options = {}) {
if (!this.isDesktopSingleSlider() || this.carouselInteractionLocked) return;

const cards = this.visibleCards();
if (cards.length < 2) return;

const oldIndex = this.activeIndex;
const target = ((Number(index) || 0) + cards.length) % cards.length;
if (target === oldIndex) return;

let direction = Number(options.direction) || 0;
if (!direction) {
const forwardDistance = (target - oldIndex + cards.length) % cards.length;
const backwardDistance = (oldIndex - target + cards.length) % cards.length;
direction = forwardDistance <= backwardDistance ? 1 : -1;
}

const outgoing = cards[oldIndex];
const incoming = cards[target];
if (!outgoing || !incoming) return;

const cardWidth = Math.max(1, outgoing.getBoundingClientRect().width);
const travel = Math.max(44, Math.min(72, cardWidth * 0.18));
const duration = 270;
const easing = 'cubic-bezier(.22,.82,.24,1)';

this.carouselInteractionLocked = true;
window.clearTimeout(this.spotlightSettleTimer);
this.carousel.classList.add('is-settling', 'is-desktop-sliding');
this.setSliderDotTransition(duration, easing);

cards.forEach(card => {
card.style.setProperty('transition', 'none', 'important');
if (card !== outgoing && card !== incoming) {
card.style.setProperty('opacity', '0', 'important');
card.style.setProperty('visibility', 'hidden', 'important');
}
});

outgoing.style.setProperty('visibility', 'visible', 'important');
outgoing.style.setProperty('opacity', '1', 'important');
outgoing.style.setProperty('z-index', '10', 'important');
outgoing.style.setProperty('filter', 'none', 'important');
outgoing.style.setProperty('clip-path', 'none', 'important');
outgoing.style.setProperty('-webkit-clip-path', 'none', 'important');
outgoing.style.setProperty('mask-image', 'none', 'important');
outgoing.style.setProperty('-webkit-mask-image', 'none', 'important');
outgoing.style.setProperty('background-color', '#F8F9FC', 'important');
outgoing.style.setProperty(
'box-shadow',
'0 18px 36px rgba(19,25,50,.11)',
'important'
);
outgoing.style.setProperty(
'transform',
'translate3d(-50%,0,0) translate3d(0,0,0) scale(1)',
'important'
);

incoming.style.setProperty('visibility', 'visible', 'important');
incoming.style.setProperty('opacity', '0', 'important');
incoming.style.setProperty('z-index', '9', 'important');
incoming.style.setProperty('filter', 'none', 'important');
incoming.style.setProperty('clip-path', 'none', 'important');
incoming.style.setProperty('-webkit-clip-path', 'none', 'important');
incoming.style.setProperty('mask-image', 'none', 'important');
incoming.style.setProperty('-webkit-mask-image', 'none', 'important');
incoming.style.setProperty('background-color', '#F8F9FC', 'important');
incoming.style.setProperty(
'box-shadow',
'0 18px 36px rgba(19,25,50,.08)',
'important'
);
incoming.style.setProperty(
'transform',
`translate3d(-50%,0,0) translate3d(${direction * travel}px,0,0) scale(.985)`,
'important'
);

void this.carousel.offsetWidth;

requestAnimationFrame(() => {
requestAnimationFrame(() => {
const transition = `transform ${duration}ms ${easing}, opacity ${duration}ms ease`;
outgoing.style.setProperty('transition', transition, 'important');
incoming.style.setProperty('transition', transition, 'important');

outgoing.style.setProperty(
'transform',
`translate3d(-50%,0,0) translate3d(${-direction * travel}px,0,0) scale(.985)`,
'important'
);
outgoing.style.setProperty('opacity', '0', 'important');
incoming.style.setProperty(
'transform',
'translate3d(-50%,0,0) translate3d(0,0,0) scale(1)',
'important'
);
incoming.style.setProperty('opacity', '1', 'important');
this.updateSliderDotsProgress(1, direction);
});
});

this.spotlightSettleTimer = window.setTimeout(() => {
this.activeIndex = target;
this.resetCardToFirstVariant(cards[target]);
this.renderCarousel();
this.clearSpotlightInlineStyles(true);
this.carousel.classList.remove('is-settling', 'is-desktop-sliding');
this.carouselInteractionLocked = false;
this.carouselDragProgress = 0;
this.carouselDragDirection = 0;
this.setSliderDotTransition(0);
this.scheduleCarouselHeight(false);
}, duration + 34);
}

settleSpotlightTo(index, options = {}) {
if (this.isGridCollection() || this.carouselInteractionLocked) return;

const cards = this.visibleCards();
if (!cards.length) return;

const oldIndex = this.activeIndex;
const target = ((Number(index) || 0) + cards.length) % cards.length;
const sameTarget = target === oldIndex;
let direction = Number(options.direction) || 0;

if (!sameTarget && !direction) {
direction = target === ((oldIndex + 1) % cards.length) ? 1 : -1;
}
if (sameTarget && !direction) {
direction = this.carouselDragDirection || 1;
}

const oldActive = cards[oldIndex];
const sideCandidate = direction === 1
? this.carousel.querySelector('.ai-bundle-product-card.next')
: this.carousel.querySelector('.ai-bundle-product-card.prev');
const incoming = sameTarget ? sideCandidate : cards[target];
const otherCards = cards.filter(card => card !== oldActive && card !== incoming);

if (!oldActive || !incoming) {
this.clearSpotlightInlineStyles(true);
this.carouselInteractionLocked = false;
return;
}

if (!sameTarget) {
this.resetCardToFirstVariant(incoming);
}

const activeRect = oldActive.getBoundingClientRect();
const cardWidth = Math.max(1, activeRect.width);
const cardHeight = Math.max(1, activeRect.height);
const sideScale = 0.972;
const sidePeek = Math.max(28, Math.min(34, cardWidth * 0.096));
const sideOffset = sidePeek + (cardWidth * ((1 - sideScale) / 2));
const sideDrop = 8;
const sideTilt = 0.35;
const sideClip = Math.max(5, Math.min(8, cardHeight * 0.014));

const releaseDx = Math.abs(Number(options.releaseDx) || 0);
const releaseVelocity = Math.abs(Number(options.releaseVelocity) || 0);
const travelled = Math.min(1, releaseDx / (cardWidth * 0.38));
const speedAssist = Math.min(1, releaseVelocity / 1.1);
const clamp = (min, value, max) => Math.max(min, Math.min(max, value));

/* V110: remove the extra post-swipe jump.
   If the user has already swiped the card nearly into place, the release
   animation should only finish the last few pixels, not replay another move. */
const releaseProgress = Math.max(
0,
Math.min(1, Number(options.startProgress) || this.carouselDragProgress || 0)
);
const remainingProgress = sameTarget ? releaseProgress : (1 - releaseProgress);

const duration = sameTarget
? Math.round(clamp(120, 205 * remainingProgress + 58 - (speedAssist * 22), 238))
: Math.round(clamp(70, 225 * remainingProgress + 42 - (speedAssist * 28), 248));

const easing = 'cubic-bezier(.20,.82,.16,1)';

this.carouselInteractionLocked = true;
this.carousel.classList.add('is-settling', 'is-card-handoff');
this.carousel.style.setProperty('--bb-swipe-duration', `${duration}ms`);
window.clearTimeout(this.spotlightSettleTimer);

cards.forEach(card => {
card.style.setProperty(
'transition',
`transform ${duration}ms ${easing}, opacity ${Math.round(duration * 0.88)}ms ease-out, background-color ${duration}ms ease-out, border-color ${duration}ms ease-out`,
'important'
);

const cardImage = card.querySelector('.ai-bundle-product-image');
if (cardImage) {
cardImage.style.setProperty(
'transition',
`transform ${duration}ms ${easing}`,
'important'
);
}
});

this.setSliderDotTransition(duration, easing);

/* Programmatic navigation begins from the exact same smaller side-card
   position used during a finger drag. */
if (!options.fromDrag) {
this.applySwipeCardColour(oldActive, 0);
this.applySwipeCardColour(incoming, 1);
oldActive.style.setProperty('transition', 'none', 'important');
oldActive.style.setProperty(
'transform',
'translate3d(-50%,0,0) translate3d(0,0,0) scale(1) rotate(0deg)',
'important'
);
oldActive.style.setProperty('opacity', '1', 'important');
oldActive.style.setProperty('visibility', 'visible', 'important');
oldActive.style.setProperty('z-index', '10', 'important');
oldActive.style.setProperty('clip-path', 'none', 'important');
oldActive.style.setProperty('-webkit-clip-path', 'none', 'important');
oldActive.style.setProperty('--bb-outgoing-image', '1');
oldActive.style.setProperty('--bb-outgoing-text', '1');
oldActive.style.setProperty('--bb-outgoing-controls', '1');

incoming.style.setProperty('transition', 'none', 'important');
incoming.style.setProperty(
'transform',
`translate3d(-50%,0,0) translate3d(${direction * sideOffset}px,${sideDrop}px,0) scale(${sideScale}) rotate(${direction * sideTilt}deg)`,
'important'
);
incoming.style.setProperty('opacity', '0.70', 'important');
incoming.style.setProperty('visibility', 'visible', 'important');
incoming.style.setProperty('z-index', '7', 'important');
incoming.style.setProperty('box-shadow', 'none', 'important');
incoming.style.setProperty('clip-path', 'none', 'important');
incoming.style.setProperty('-webkit-clip-path', 'none', 'important');
incoming.style.setProperty('--bb-image-reveal', '0');
incoming.style.setProperty('--bb-text-reveal', '0');
incoming.style.setProperty('--bb-controls-reveal', '0');

}

otherCards.forEach(card => {
card.style.setProperty('transition', 'none', 'important');
card.style.setProperty('opacity', '0', 'important');
card.style.setProperty('visibility', 'hidden', 'important');
card.style.setProperty('box-shadow', 'none', 'important');
});

void this.carousel.offsetWidth;

cards.forEach(card => {
card.style.setProperty(
'transition',
`transform ${duration}ms ${easing}, opacity ${Math.round(duration * 0.88)}ms ease-out, background-color ${duration}ms ease-out, border-color ${duration}ms ease-out`,
'important'
);
const cardImage = card.querySelector('.ai-bundle-product-image');
if (cardImage) {
cardImage.style.setProperty(
'transition',
`transform ${duration}ms ${easing}`,
'important'
);
}
});

requestAnimationFrame(() => {
this.updateSliderDotsProgress(sameTarget ? 0 : 1, direction);

if (sameTarget) {
/* Cancelled swipe: current card returns to centre while the side card
   shrinks back into its side position and the static slice fades in. */
this.applySwipeCardColour(oldActive, 0);
this.applySwipeCardColour(incoming, 1);

oldActive.style.setProperty(
'transform',
'translate3d(-50%,0,0) translate3d(0,0,0) scale(1) rotate(0deg)',
'important'
);
oldActive.style.setProperty('opacity', '1', 'important');
oldActive.style.setProperty('visibility', 'visible', 'important');
oldActive.style.setProperty('z-index', '10', 'important');
oldActive.style.setProperty('clip-path', 'none', 'important');
oldActive.style.setProperty('-webkit-clip-path', 'none', 'important');
oldActive.style.setProperty('--bb-outgoing-image', '1');
oldActive.style.setProperty('--bb-outgoing-text', '1');
oldActive.style.setProperty('--bb-outgoing-controls', '1');

incoming.style.setProperty(
'transform',
`translate3d(-50%,0,0) translate3d(${direction * sideOffset}px,${sideDrop}px,0) scale(${sideScale}) rotate(${direction * sideTilt}deg)`,
'important'
);
incoming.style.setProperty('opacity', '0.70', 'important');
incoming.style.setProperty('visibility', 'visible', 'important');
incoming.style.setProperty('z-index', '7', 'important');
incoming.style.setProperty('clip-path', 'none', 'important');
incoming.style.setProperty('-webkit-clip-path', 'none', 'important');
incoming.style.setProperty('--bb-image-reveal', '0');
incoming.style.setProperty('--bb-text-reveal', '0');
incoming.style.setProperty('--bb-controls-reveal', '0');
return;
}

/* Completed swipe: the old card becomes the smaller opposite side card,
   while the following card grows directly into the centre. */
this.applySwipeCardColour(oldActive, 1);
this.applySwipeCardColour(incoming, 0);

oldActive.style.setProperty(
'transform',
`translate3d(-50%,0,0) translate3d(${-direction * sideOffset}px,${sideDrop}px,0) scale(${sideScale}) rotate(${-direction * sideTilt}deg)`,
'important'
);
oldActive.style.setProperty('opacity', '0.62', 'important');
oldActive.style.setProperty('visibility', 'visible', 'important');
oldActive.style.setProperty('z-index', '7', 'important');
oldActive.style.setProperty('box-shadow', 'none', 'important');
oldActive.style.setProperty('clip-path', 'none', 'important');
oldActive.style.setProperty('-webkit-clip-path', 'none', 'important');
oldActive.style.setProperty('--bb-outgoing-image', '0');
oldActive.style.setProperty('--bb-outgoing-text', '0');
oldActive.style.setProperty('--bb-outgoing-controls', '0');

incoming.style.setProperty(
'transform',
'translate3d(-50%,0,0) translate3d(0,0,0) scale(1) rotate(0deg)',
'important'
);
incoming.style.setProperty('opacity', '1', 'important');
incoming.style.setProperty('visibility', 'visible', 'important');
incoming.style.setProperty('z-index', '10', 'important');
incoming.style.setProperty('box-shadow', 'none', 'important');
incoming.style.setProperty('clip-path', 'none', 'important');
incoming.style.setProperty('-webkit-clip-path', 'none', 'important');
incoming.style.setProperty('mask-image', 'none', 'important');
incoming.style.setProperty('-webkit-mask-image', 'none', 'important');
incoming.style.setProperty('--bb-image-reveal', '1');
incoming.style.setProperty('--bb-text-reveal', '1');
incoming.style.setProperty('--bb-controls-reveal', '1');

const oldImage = oldActive.querySelector('.ai-bundle-product-image');
const incomingImage = incoming.querySelector('.ai-bundle-product-image');

if (oldImage) {
oldImage.style.setProperty(
'transform',
`translate3d(${-direction * 0.5}px,0,0) scale(1)`,
'important'
);
}
if (incomingImage) {
incomingImage.style.setProperty(
'transform',
'translate3d(0,0,0) scale(1)',
'important'
);
}
});

this.spotlightSettleTimer = window.setTimeout(() => {
/* V110: freeze the stage height during the class-role handoff. This prevents
   the featured card from looking perfect, then jumping again when JS removes
   the temporary swipe height. */
const lockedStageHeight = Math.max(
1,
Math.ceil(this.carousel.getBoundingClientRect().height)
);

/* Commit the new card roles atomically while all transitions remain frozen.
   Keeping the final sampled colours inline for one painted frame prevents the
   old and new rear-card class colours from flashing during the role swap. */
this.carousel.classList.add('is-handoff-commit', 'is-swipe-finalising');
cards.forEach(card => {
card.style.setProperty('transition', 'none', 'important');
const cardImage = card.querySelector('.ai-bundle-product-image');
if (cardImage) cardImage.style.setProperty('transition', 'none', 'important');
});

if (!sameTarget) {
this.activeIndex = target;
this.renderCarousel();
}

const committedCards = this.visibleCards();
committedCards.forEach(card => {
this.applySwipeCardColour(card, card.classList.contains('active') ? 0 : 1);
});

/* Force the complete class, geometry and colour state into the same frame. */
void this.carousel.offsetWidth;

requestAnimationFrame(() => {
requestAnimationFrame(() => {
this.clearSpotlightInlineStyles(true);
this.carouselDragProgress = 0;
this.carouselDragDirection = 0;
this.setSliderDotTransition(0);

this.carousel.classList.remove('is-settling', 'is-card-handoff', 'is-handoff-commit', 'is-swipe-height-locked');
this.carousel.style.setProperty('height', `${lockedStageHeight}px`);
this.carousel.style.removeProperty('--bb-swipe-duration');

this.carouselInteractionLocked = false;
this.syncPodiumGeometry();

/* Keep transitions disabled for one final paint after inline styles are cleared,
   then return to normal. */
window.setTimeout(() => {
if (this.carousel) this.carousel.classList.remove('is-swipe-finalising');
}, 80);
});
});
}, duration + 10);
}

goToSlide(index) {
if (this.isGridCollection()) return;
const cards = this.visibleCards();
if (!cards.length) return;
const target = Math.max(0, Math.min(cards.length - 1, Number(index) || 0));
if (this.isDesktopSingleSlider()) {
this.settleDesktopSliderTo(target);
return;
}
this.settleSpotlightTo(target);
}

renderSliderDots(cards, isGrid) {
if (!this.sliderDots) return;

if (isGrid || cards.length < 2) {
this.sliderDots.hidden = true;
this.sliderDots.innerHTML = '';
return;
}

this.sliderDots.hidden = false;
this.sliderDots.innerHTML = cards.map((card, index) => {
const title = card.dataset.displayTitle || `Product ${index + 1}`;
const active = index === this.activeIndex;
return `<button type="button" class="ai-bundle-slider-dot${active ? ' active' : ''}" data-slide-index="${index}" role="tab" aria-selected="${active ? 'true' : 'false'}" aria-label="Show ${this.escape(title)}"></button>`;
}).join('');
}

currentViewportWidth() {
return Math.round((window.visualViewport && window.visualViewport.width) || window.innerWidth || document.documentElement.clientWidth || 0);
}
currentViewportHeight() {
return Math.round((window.visualViewport && window.visualViewport.height) || window.innerHeight || document.documentElement.clientHeight || 0);
}
captureVisibleViewportInsets() {
const viewport = window.visualViewport;
const layoutWidth = Math.max(
window.innerWidth || 0,
document.documentElement.clientWidth || 0
);
const layoutHeight = Math.max(
window.innerHeight || 0,
document.documentElement.clientHeight || 0
);

const visibleWidth = Math.max(
280,
Math.round((viewport && viewport.width) || layoutWidth || 0)
);
const visibleHeight = Math.max(
320,
Math.round((viewport && viewport.height) || layoutHeight || 0)
);
const visibleTop = Math.max(
0,
Math.round((viewport && viewport.offsetTop) || 0)
);
const visibleLeft = Math.max(
0,
Math.round((viewport && viewport.offsetLeft) || 0)
);
const visibleBottom = visibleTop + visibleHeight;
const bottomGap = Math.max(
0,
Math.round(layoutHeight - visibleBottom)
);
const centreX = visibleLeft + (visibleWidth / 2);
const centreY = visibleTop + (visibleHeight / 2);

this.style.setProperty('--ai-visual-viewport-width', `${visibleWidth}px`);
this.style.setProperty('--ai-visual-viewport-height', `${visibleHeight}px`);
this.style.setProperty('--ai-visual-viewport-top', `${visibleTop}px`);
this.style.setProperty('--ai-visual-viewport-left', `${visibleLeft}px`);
this.style.setProperty('--ai-visual-viewport-centre-x', `${centreX}px`);
this.style.setProperty('--ai-visual-viewport-centre-y', `${centreY}px`);
this.style.setProperty('--ai-browser-bottom-gap', `${bottomGap}px`);
}

captureStableViewportHeight(force = false) {
const width = this.currentViewportWidth();
const height = Math.max(320, this.currentViewportHeight());
const widthChanged =
!this.stableViewportWidth ||
Math.abs(width - this.stableViewportWidth) > 24;
const heightChanged =
!this.stableViewportHeight ||
Math.abs(height - this.stableViewportHeight) > 2;

if (!force && !widthChanged && !heightChanged) {
this.captureVisibleViewportInsets();
return false;
}

this.stableViewportWidth = width;
this.stableViewportHeight = height;
this.style.setProperty('--ai-stable-viewport-height', `${height}px`);
this.captureVisibleViewportInsets();
return widthChanged || heightChanged;
}

clearViewportSettleTimers() {
this.viewportSettleTimers.forEach(timer => window.clearTimeout(timer));
this.viewportSettleTimers = [];
}

settleViewportAfterOpen() {
this.clearViewportSettleTimers();

const refresh = () => {
if (
!this.popup ||
(
!this.popup.classList.contains('active') &&
!this.popup.classList.contains('is-mounted')
)
) return;

this.captureStableViewportHeight(true);
this.scheduleCarouselHeight(true);
this.syncContentOverflow();
};

requestAnimationFrame(() => {
requestAnimationFrame(refresh);
});

[60, 180, 360].forEach(delay => {
this.viewportSettleTimers.push(window.setTimeout(refresh, delay));
});
}


freezeOpenViewport() {
const viewport = window.visualViewport;
const layoutWidth = Math.max(
window.innerWidth || 0,
document.documentElement.clientWidth || 0
);
const layoutHeight = Math.max(
window.innerHeight || 0,
document.documentElement.clientHeight || 0
);

const width = Math.max(
280,
Math.round((viewport && viewport.width) || layoutWidth || 0)
);
const visibleHeight = Math.max(
320,
Math.round((viewport && viewport.height) || layoutHeight || 0)
);
const visibleTop = Math.max(
0,
Math.round((viewport && viewport.offsetTop) || 0)
);
const visibleLeft = Math.max(
0,
Math.round((viewport && viewport.offsetLeft) || 0)
);
const visibleBottom = visibleTop + visibleHeight;
const bottomGap = Math.max(
0,
Math.round(layoutHeight - visibleBottom)
);
const centreX = visibleLeft + (width / 2);
const centreY = visibleTop + (visibleHeight / 2);

/* V105 uses the visual viewport centre for a stable modal card.
   The old bottom drawer variables are kept only as harmless fallbacks. */

/* V103: Drawer is anchored to the bottom, never the top.
   On tall phone viewports, cap the drawer height to the compact size that
   looks best when the browser bottom bar is visible. */
const isPhoneLike = width <= 520;
const compactCap = width <= 390 ? 706 : 724;
const availablePopupHeight = Math.max(520, visibleHeight - 12);
const popupHeight = isPhoneLike
? Math.max(600, Math.min(availablePopupHeight, compactCap))
: availablePopupHeight;

this.style.setProperty('--ai-frozen-viewport-width', `${width}px`);
this.style.setProperty('--ai-frozen-viewport-height', `${visibleHeight}px`);
this.style.setProperty('--ai-frozen-popup-height', `${popupHeight}px`);
this.style.setProperty('--ai-frozen-viewport-top', `${visibleTop}px`);
this.style.setProperty('--ai-frozen-viewport-left', `${visibleLeft}px`);
this.style.setProperty('--ai-frozen-viewport-centre-x', `${centreX}px`);
this.style.setProperty('--ai-frozen-viewport-centre-y', `${centreY}px`);
this.style.setProperty('--ai-frozen-browser-bottom-gap', `${bottomGap}px`);
this.classList.add('is-viewport-frozen');
}

clearOpenViewportFreeze() {
this.classList.remove('is-viewport-frozen');
[
'--ai-frozen-viewport-width',
'--ai-frozen-viewport-height',
'--ai-frozen-popup-height',
'--ai-frozen-viewport-top',
'--ai-frozen-viewport-left',
'--ai-frozen-viewport-centre-x',
'--ai-frozen-viewport-centre-y',
'--ai-frozen-browser-bottom-gap'
].forEach(name => this.style.removeProperty(name));
}

lockThemeScroll() {
const targets = [
this.popup,
this.content
].filter(Boolean);

targets.forEach(target => {
target.dispatchEvent(new CustomEvent('theme:scroll:lock', {
bubbles: true
}));
});
}

unlockThemeScroll() {
const targets = [
this.popup,
this.content
].filter(Boolean);

targets.forEach(target => {
target.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
bubbles: true
}));
});
}

lockPageScroll() {
if (this.pageScrollLock) return;
const body = document.body;
const html = document.documentElement;
const scrollX = window.scrollX || window.pageXOffset || 0;
const scrollY = window.scrollY || window.pageYOffset || 0;
const scrollbarWidth = Math.max(0, window.innerWidth - html.clientWidth);
const computedPaddingRight = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
this.pageScrollLock = {
scrollX,
scrollY,
body: {
position: body.style.position,
top: body.style.top,
left: body.style.left,
right: body.style.right,
width: body.style.width,
overflow: body.style.overflow,
paddingRight: body.style.paddingRight,
scrollBehavior: body.style.scrollBehavior
},
html: {
overflow: html.style.overflow,
overscrollBehavior: html.style.overscrollBehavior,
scrollBehavior: html.style.scrollBehavior
}
};
body.style.position = 'fixed';
body.style.top = '-' + scrollY + 'px';
body.style.left = '-' + scrollX + 'px';
body.style.right = '0';
body.style.width = '100%';
body.style.overflow = 'hidden';
if (scrollbarWidth > 0) body.style.paddingRight = (computedPaddingRight + scrollbarWidth) + 'px';
html.style.overflow = 'hidden';
html.style.overscrollBehavior = 'none';
}
unlockPageScroll() {
if (!this.pageScrollLock) return;
const body = document.body;
const html = document.documentElement;
const lock = this.pageScrollLock;
body.style.position = lock.body.position;
body.style.top = lock.body.top;
body.style.left = lock.body.left;
body.style.right = lock.body.right;
body.style.width = lock.body.width;
body.style.overflow = lock.body.overflow;
body.style.paddingRight = lock.body.paddingRight;
html.style.overflow = lock.html.overflow;
html.style.overscrollBehavior = lock.html.overscrollBehavior;
html.style.scrollBehavior = 'auto';
body.style.scrollBehavior = 'auto';
this.pageScrollLock = null;
window.scrollTo(lock.scrollX, lock.scrollY);
requestAnimationFrame(() => {
html.style.scrollBehavior = lock.html.scrollBehavior;
body.style.scrollBehavior = lock.body.scrollBehavior;
});
}
resetOpeningView() {
/* Every fresh open starts on the first supplement product. This resets only
   navigation/view state; the customer's selected bundle remains untouched. */
window.clearTimeout(this.collectionTransitionTimer);
this.collectionSwitchLocked = false;
this.cancelCarouselGesture();
this.activeCollection = '1';
this.activeIndex = 0;
this.editingUid = null;

this.primaryNavBtns.forEach(btn => {
btn.classList.toggle('active', btn.dataset.collection === '1');
});

if (this.navWrap) this.navWrap.classList.remove('is-switching');
if (this.carousel) {
this.carousel.classList.remove(
'is-collection-leaving',
'is-collection-entering',
'is-grid-view',
'is-two-column-grid',
'is-single-column-grid'
);
}
if (this.popup) this.popup.classList.remove('is-addons-view', 'is-items-view');
this.clearSupplementFitMode();
if (this.footer) this.footer.classList.remove('is-addons-view');
this.closeDrawer({ immediate: true });

if (this.content) {
this.content.scrollTo({ top: 0, behavior: 'auto' });
}

this.updateProgress();
}
openPopup() {
if (this.popup.classList.contains('active') &&
!this.popup.classList.contains('is-closing')) return;

clearTimeout(this.popupTransitionTimer);
window.clearTimeout(this.headerSettleTimer);
document.documentElement.classList.remove('camelus-bundle-closing-header');
document.documentElement.classList.add('camelus-bundle-builder-open');
document
.querySelectorAll('[data-header-wrapper], .header__wrapper')
.forEach(header => {
header.classList.remove('camelus-header-delayed-after-bundle');
});
this.clearOpenViewportFreeze();
this.overlay.classList.remove('is-closing', 'is-scroll-curtain');
this.popup.classList.remove('is-closing');
this.overlay.style.removeProperty('pointer-events');
this.popup.style.removeProperty('pointer-events');

this.resetOpeningView();

clearTimeout(this.popupTransitionTimer);
clearTimeout(this.spotlightSettleTimer);
clearTimeout(this.finalMilestoneTimer);
clearTimeout(this.popupGestureResetTimer);
this.popup.classList.remove('is-popup-dragging', 'is-popup-settling');
if (this.popupGestureRaf) { cancelAnimationFrame(this.popupGestureRaf); this.popupGestureRaf = 0; }
this.popup.style.removeProperty('--popup-drag-y');
this.overlay.style.removeProperty('--popup-drag-progress');
this.captureStableViewportHeight(true);
/* V107: centred modal does not use theme scroll lock.
   Overlay/popup capture interaction while open; page is fully released on close. */
this.captureStableViewportHeight(true);
this.freezeOpenViewport();

/* V112: isolated modal-only page lock.
   Freeze the storefront at its exact current position while the centred
   builder is open. This does not use Pipeline's theme scroll-lock events. */
this.lockPageScroll();

this.classList.add('is-open');
this.hideChatButton();

this.popup.setAttribute('aria-hidden', 'false');
if (this.fab) this.fab.setAttribute('aria-expanded', 'true');

/* Prepare the first supplement slide while the popup is still invisible.
   This prevents the real cards from briefly shuffling through their default
   positions when the builder is reopened. */
this.popup.classList.add('is-opening-prepared');
this.overlay.classList.add('is-mounted');
this.popup.classList.add('is-mounted');

this.renderCarousel();
void this.popup.offsetWidth;
this.measureCarouselHeight(true);
this.syncPodiumGeometry();
requestAnimationFrame(() => {
/* Re-measure once the mounted popup has completed layout, but before reveal. */
this.renderCarousel();
this.measureCarouselHeight(true);
this.syncPodiumGeometry();
requestAnimationFrame(() => {
this.overlay.classList.add('active');
this.popup.classList.add('active');
this.updateMobileArrowVisibility();
this.settleViewportAfterOpen();

requestAnimationFrame(() => {
this.popup.classList.remove('is-opening-prepared');
});

window.setTimeout(() => {
if (!this.popup.classList.contains('active')) return;
this.captureStableViewportHeight(true);
this.scheduleCarouselHeight(true);
this.syncContentOverflow();
/* V101: Do not force-focus the close button on iOS Safari. */
}, 90);
});
});
}

closePopup() {
if (this.popup.classList.contains('is-closing')) return;
if (!this.popup.classList.contains('active') &&
!this.popup.classList.contains('is-mounted')) return;

this.cancelCarouselGesture();
this.clearViewportSettleTimers();
clearTimeout(this.popupTransitionTimer);
clearTimeout(this.headerSettleTimer);

document.documentElement.classList.remove(
'camelus-bundle-closing-header',
'camelus-bundle-builder-open'
);
document
.querySelectorAll('[data-header-wrapper], .header__wrapper')
.forEach(header => {
header.classList.remove('camelus-header-delayed-after-bundle');
});

/* V106: centred modal close should release the page immediately.
   The old curtain kept the overlay interactive for too long, which made the
   underlying product page feel frozen after closing. */
this.overlay.classList.add('is-closing');
this.overlay.classList.remove('active', 'is-scroll-curtain');
this.popup.classList.add('is-closing');
this.popup.classList.remove('active', 'is-opening-prepared');
this.popup.setAttribute('aria-hidden', 'true');
if (this.fab) this.fab.setAttribute('aria-expanded', 'false');

this.closeDrawer({ immediate: true });
this.clearSupplementFitMode();

/* V112: restore the exact storefront scroll position immediately.
   The overlay can still fade visually, but the page is no longer locked. */
this.unlockPageScroll();

this.popupTransitionTimer = window.setTimeout(() => {
this.popup.classList.remove(
'is-mounted',
'is-closing',
'is-drawer-open',
'is-drawer-returning',
'is-items-view',
'is-popup-dragging',
'is-popup-settling'
);

this.overlay.classList.remove(
'is-mounted',
'is-closing',
'is-scroll-curtain',
'active'
);

this.classList.remove('is-open');

if (this.popupGestureRaf) {
cancelAnimationFrame(this.popupGestureRaf);
this.popupGestureRaf = 0;
}

this.popup.style.removeProperty('--popup-drag-y');
this.overlay.style.removeProperty('--popup-drag-progress');
this.clearOpenViewportFreeze();

/* Hard release: no hidden builder layer may keep catching product-page taps. */
this.overlay.style.setProperty('pointer-events', 'none', 'important');
this.popup.style.setProperty('pointer-events', 'none', 'important');
this.drawerBackdrop?.style?.setProperty('pointer-events', 'none', 'important');
this.drawer?.style?.setProperty('pointer-events', 'none', 'important');

window.setTimeout(() => {
this.overlay.style.removeProperty('pointer-events');
this.popup.style.removeProperty('pointer-events');
if (this.drawerBackdrop) this.drawerBackdrop.style.removeProperty('pointer-events');
if (this.drawer) this.drawer.style.removeProperty('pointer-events');
}, 80);

this.showChatButton();
this.lastOpenTrigger = null;
}, 260);
}

hideChatButton() {
const selectors = [
'#dummy-chat-button-iframe',
'#shopify-chat',
'#ShopifyChat',
'shopify-agent[view="chat"]',
'.activator-nudge.activator-nudge--active',
'.activator-nudge',
'button.activator[aria-label="Chat"]',
'[part="activator"][aria-label="Chat"]',
'.jdgm-revs-tab',
'.jdgm-revs-tab-btn',
'#looxReviewsFloatingTab',
'.loox-floating-widget',
'.loox-float-toggler-container',
'.loox-float-toggler-container-right',
'#loox-floating-widget-btn',
'.loox-float-toggler',
'.loox-floating-widget-btn',
'.stamped-reviews-floating-tab',
'.stamped-reviews-tab',
'[data-reviews-floating-tab]'
].join(', ');
const hideElement = element => {
if (!element || this.contains(element)) return;
if (!this.chatButtonStates.has(element)) {
this.chatButtonStates.set(element, {
display: element.style.getPropertyValue('display'),
priority: element.style.getPropertyPriority('display')
});
}
element.style.setProperty('display', 'none', 'important');
};
const hideMatches = () => {
document.querySelectorAll(selectors).forEach(hideElement);
document.querySelectorAll('[aria-label*="review" i], [title*="review" i]').forEach(element => {
const styles = window.getComputedStyle(element);
if (styles.position === 'fixed' || styles.position === 'sticky') {
hideElement(element);
}
});
};
hideMatches();
if (this.chatObserver) this.chatObserver.disconnect();
this.chatObserver = new MutationObserver(() => hideMatches());
this.chatObserver.observe(document.documentElement, {
childList: true,
subtree: true,
attributes: true,
attributeFilter: ['view', 'class', 'aria-label']
});
}
showChatButton() {
if (this.chatObserver) {
this.chatObserver.disconnect();
this.chatObserver = null;
}
this.chatButtonStates.forEach((state, chatButton) => {
if (!chatButton.isConnected) return;
if (state.display) {
chatButton.style.setProperty('display', state.display, state.priority || '');
} else {
chatButton.style.removeProperty('display');
}
});
this.chatButtonStates.clear();
}
disconnectedCallback() {
if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
if (this.resizeHandler && window.visualViewport) {
window.visualViewport.removeEventListener('resize', this.resizeHandler);
window.visualViewport.removeEventListener('scroll', this.resizeHandler);
}
if (this.orientationHandler) window.removeEventListener('orientationchange', this.orientationHandler);
if (this.viewportResizeRaf) cancelAnimationFrame(this.viewportResizeRaf);
this.clearViewportSettleTimers();
if (this.keydownHandler) document.removeEventListener('keydown', this.keydownHandler);
if (this.externalOpenHandler) document.removeEventListener('camelus:open-bundle-builder', this.externalOpenHandler);
if (this.externalTriggerClickHandler) document.removeEventListener('click', this.externalTriggerClickHandler);
if (this.pageReleaseHandler) window.removeEventListener('pagehide', this.pageReleaseHandler);
if (this.externalTriggerPointerHandler) document.removeEventListener('pointerup', this.externalTriggerPointerHandler);
if (this.carousel) {
if (this.onCarouselPointerDown) this.carousel.removeEventListener('pointerdown', this.onCarouselPointerDown);
if (this.onCarouselPointerMove) this.carousel.removeEventListener('pointermove', this.onCarouselPointerMove);
if (this.carouselTouchMoveBlocker) this.carousel.removeEventListener('touchmove', this.carouselTouchMoveBlocker);
if (this.onCarouselClickCapture) this.carousel.removeEventListener('click', this.onCarouselClickCapture, true);
}
if (this.onCarouselPointerUp) window.removeEventListener('pointerup', this.onCarouselPointerUp, true);
if (this.onCarouselPointerCancel) window.removeEventListener('pointercancel', this.onCarouselPointerCancel, true);
this.cancelCarouselGesture();
clearTimeout(this.drawerGestureResetTimer);
clearTimeout(this.popupGestureResetTimer);
if (this.popupGestureRaf) cancelAnimationFrame(this.popupGestureRaf);
if (this.popup) {
if (this.onPopupPointerDown) this.popup.removeEventListener('pointerdown', this.onPopupPointerDown);
if (this.onPopupPointerMove) this.popup.removeEventListener('pointermove', this.onPopupPointerMove);
if (this.onPopupPointerEnd) {
this.popup.removeEventListener('pointerup', this.onPopupPointerEnd);
this.popup.removeEventListener('pointercancel', this.onPopupPointerEnd);
}
}
clearTimeout(this.collectionTransitionTimer);
clearTimeout(this.popupTransitionTimer);
this.unlockPageScroll();
this.clearOpenViewportFreeze();
this.classList.remove('is-open', 'is-ready');
if (this.overlay) this.overlay.classList.remove('active', 'is-mounted');
if (this.popup) this.popup.classList.remove('active', 'is-mounted');
if (this.drawerBackdrop) this.drawerBackdrop.classList.remove('active', 'is-mounted');
if (this.drawer) this.drawer.classList.remove('active', 'is-mounted', 'is-dragging');
this.unlockPageScroll();
this.showChatButton();
}
switchCollection(collection) {
const targetCollection = String(collection);
if (
targetCollection === this.activeCollection ||
this.collectionSwitchLocked ||
!this.carousel
) return;

this.cancelCarouselGesture();
this.resetSpotlightTilt();
this.carouselInteractionLocked = false;
this.collectionSwitchLocked = true;
window.clearTimeout(this.collectionTransitionTimer);

const startHeight = Math.max(1, this.carousel.getBoundingClientRect().height);

/* The tab responds immediately, while the products leave softly. */
this.primaryNavBtns.forEach(btn => {
btn.classList.toggle('active', btn.dataset.collection === targetCollection);
});
if (this.navWrap) this.navWrap.classList.add('is-switching');
this.carousel.classList.add('is-collection-leaving');
this.carousel.classList.remove('is-collection-entering');

this.collectionTransitionTimer = window.setTimeout(() => {
this.activeCollection = targetCollection;
this.activeIndex = 0;
this.editingUid = null;
this.clearSupplementFitMode();

this.renderCarousel();
this.updateCardButtons();
this.updateProgress();

if (this.content) {
this.content.scrollTo({ top: 0, behavior: 'auto' });
if (targetCollection === '2') {
this.content.classList.add('is-scrollable');
}
}

this.syncContentOverflow();

/* Measure the destination layout, then animate the carousel height rather
   than allowing the supplement card and add-on grid to jump. */
let targetHeight = startHeight;

if (this.isGridCollection()) {
this.carousel.style.height = 'auto';
targetHeight = Math.max(1, Math.ceil(this.carousel.scrollHeight));
} else {
this.measureCarouselHeight(true);
targetHeight = Math.max(
1,
parseFloat(this.carousel.style.height) ||
this.carousel.getBoundingClientRect().height
);
}

this.carousel.style.height = `${startHeight}px`;
void this.carousel.offsetHeight;
this.carousel.style.height = `${targetHeight}px`;

this.carousel.classList.remove('is-collection-leaving');
this.carousel.classList.add('is-collection-entering');

requestAnimationFrame(() => {
requestAnimationFrame(() => {
this.carousel.classList.remove('is-collection-entering');
});
});

this.collectionTransitionTimer = window.setTimeout(() => {
if (this.isGridCollection()) {
this.carousel.style.height = 'auto';
} else {
this.scheduleCarouselHeight(true);
}

this.carousel.classList.remove(
'is-collection-leaving',
'is-collection-entering'
);
if (this.navWrap) this.navWrap.classList.remove('is-switching');
this.collectionSwitchLocked = false;
this.syncContentOverflow();
}, 300);
}, 125);
}
updateNav() {
this.primaryNavBtns.forEach(btn => btn.classList.toggle('active', btn.dataset.collection === this.activeCollection));
}
clearCarouselInlineStyles() {
this.cards.forEach(card => {
card.style.removeProperty('transform');
card.style.removeProperty('opacity');
card.style.removeProperty('filter');
card.style.removeProperty('box-shadow');
card.style.removeProperty('-webkit-mask-image');
card.style.removeProperty('mask-image');
card.style.removeProperty('transition');
card.style.removeProperty('visibility');
card.style.removeProperty('background-color');
card.style.removeProperty('border-color');
card.style.removeProperty('will-change');
});
}
cancelCarouselGesture() {
clearTimeout(this.carouselTransitionTimer);
clearTimeout(this.spotlightSettleTimer);
this.carouselInteractionLocked = false;
this.dragState = null;
if (this.carousel) {
this.carousel.classList.remove('is-gesture-ready', 'is-dragging', 'is-settling', 'is-card-handoff', 'is-desktop-sliding', 'is-swipe-height-locked');
this.carousel.style.removeProperty('height');
this.carousel.style.removeProperty('--bb-swipe-duration');
}
this.clearCarouselInlineStyles();
}
moveCarousel(direction) {
if (this.isGridCollection()) return;
const cards = this.visibleCards();
if (cards.length < 2) return;
const step = direction === 'prev' ? -1 : 1;
const target = (this.activeIndex + step + cards.length) % cards.length;
if (this.isDesktopSingleSlider()) {
this.settleDesktopSliderTo(target, { direction: step });
return;
}
this.settleSpotlightTo(target);
}

renderCarousel() {
this.updateMobileArrowVisibility();
const cards = this.visibleCards();
const isGrid = this.isGridCollection();
const isTwoColumnGrid = this.isTwoColumnGridCollection();

if (this.desktopSliderControls) {
const controlsAvailable = !isGrid && cards.length > 1;
this.desktopSliderControls.hidden = !controlsAvailable;
this.desktopSliderControls.setAttribute('aria-hidden', controlsAvailable ? 'false' : 'true');
}

if (this.carousel) {
this.carousel.classList.toggle('is-grid-view', isGrid);
this.carousel.classList.toggle('is-two-column-grid', isGrid && isTwoColumnGrid);
this.carousel.classList.remove('is-single-column-grid');
this.carousel.classList.toggle('is-simple-slider', !isGrid);
this.carousel.setAttribute('aria-roledescription', isGrid ? 'product grid' : 'carousel');
this.carousel.setAttribute('aria-label', isGrid
? 'Add-on products. Scroll to browse.'
: 'Supplements. Swipe left or right to browse products.');
}

this.cards.forEach(card => {
const inCollection = card.dataset.collection === this.activeCollection;
card.classList.remove('active', 'prev', 'next', 'far', 'grid-item');
card.style.removeProperty('--grid-index');
card.querySelectorAll('.ai-bundle-card-position').forEach(indicator => indicator.remove());

if (!inCollection) {
card.style.setProperty('display', 'none', 'important');
card.setAttribute('aria-hidden', 'true');
if ('inert' in card) card.inert = true;
return;
}

card.style.setProperty('display', 'flex', 'important');
card.setAttribute('aria-hidden', 'true');
if ('inert' in card) card.inert = true;
});

if (!cards.length) {
this.renderSliderDots([], true);
if (this.carousel) this.carousel.style.height = '120px';
return;
}

if (isGrid) {
this.activeIndex = 0;
cards.forEach((card, index) => {
const title = card.dataset.displayTitle || (card.querySelector('.ai-bundle-product-title') || {}).textContent || 'Product';
const counter = card.querySelector('.ai-bundle-card-counter');
if (counter) {
counter.innerHTML = `<span class="ai-bundle-card-counter-current">${index + 1}</span><span class="ai-bundle-card-counter-total">/${cards.length}</span>`;
counter.hidden = true;
}
card.classList.add('grid-item');
card.style.setProperty('--grid-index', String(index));
card.setAttribute('role', 'article');
card.setAttribute('aria-label', `${index + 1} of ${cards.length}: ${String(title).trim()}`);
card.setAttribute('aria-hidden', 'false');
if ('inert' in card) card.inert = false;
});
this.renderSliderDots(cards, true);
if (this.carousel) this.carousel.style.height = 'auto';
this.syncContentOverflow();
return;
}

if (this.activeIndex < 0 || this.activeIndex >= cards.length) this.activeIndex = 0;

const previousIndex = cards.length > 2
? (this.activeIndex - 1 + cards.length) % cards.length
: -1;
const nextIndex = cards.length > 1
? (this.activeIndex + 1) % cards.length
: -1;

cards.forEach((card, index) => {
const title = card.dataset.displayTitle || (card.querySelector('.ai-bundle-product-title') || {}).textContent || 'Product';
const counter = card.querySelector('.ai-bundle-card-counter');
if (counter) {
counter.innerHTML = `<span class="ai-bundle-card-counter-current">${index + 1}</span><span class="ai-bundle-card-counter-total">/${cards.length}</span>`;
counter.hidden = false;
}
const isActive = index === this.activeIndex;
const isPrevious = index === previousIndex;
const isNext = index === nextIndex;

card.classList.toggle('active', isActive);
card.classList.toggle('prev', isPrevious);
card.classList.toggle('next', isNext);
card.classList.toggle('far', !isActive && !isPrevious && !isNext);

card.setAttribute('role', 'group');
card.setAttribute('aria-roledescription', 'slide');
card.setAttribute('aria-label', `${index + 1} of ${cards.length}: ${String(title).trim()}`);
card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
if ('inert' in card) card.inert = !isActive;
this.applySwipeCardColour(card, isActive ? 0 : 1);
});

this.renderSliderDots(cards, false);
if (this.carousel) this.carousel.classList.remove('has-podium', 'has-deck');
this.scheduleCarouselHeight(false);
}

syncPodiumGeometry() {
if (!this.carousel || this.isGridCollection() || this.isDesktopSingleSlider()) {
if (this.carousel) {
this.carousel.classList.remove('has-podium', 'has-deck');
this.carousel.style.removeProperty('--bb-side-scale');
this.carousel.style.removeProperty('--bb-side-offset');
this.carousel.style.removeProperty('--bb-side-drop');
this.carousel.style.removeProperty('--bb-side-clip');
this.carousel.style.removeProperty('--bb-side-tilt');
}
return;
}

const cards = this.visibleCards();
const active = cards[this.activeIndex];

if (!active || cards.length < 2) {
this.carousel.classList.remove('has-podium', 'has-deck');
return;
}

const activeRect = active.getBoundingClientRect();

if (activeRect.width < 1 || activeRect.height < 1) {
this.carousel.classList.remove('has-podium', 'has-deck');
return;
}

const deckScale = 0.955;
const deckPeek = Math.max(30, Math.min(36, activeRect.width * 0.102));
const deckOffset = deckPeek + (activeRect.width * ((1 - deckScale) / 2));
const deckDrop = Math.max(11, Math.min(13, activeRect.height * 0.022));
const deckInset = Math.max(5, Math.min(8, activeRect.height * 0.014));

/* V70: only the real previous/next cards form the deck. The old
   has-deck/podium classes and variables are intentionally never activated. */
this.carousel.classList.remove('has-podium', 'has-deck');
this.carousel.style.setProperty('--bb-side-scale', deckScale.toFixed(3));
this.carousel.style.setProperty('--bb-side-offset', `${deckOffset.toFixed(2)}px`);
this.carousel.style.setProperty('--bb-side-drop', `${deckDrop.toFixed(2)}px`);
this.carousel.style.setProperty('--bb-side-clip', `${deckInset.toFixed(2)}px`);
this.carousel.style.setProperty('--bb-side-tilt', '1.35deg');
}

isMobileSupplementFitView() {
return Boolean(
this.popup &&
(
this.popup.classList.contains('active') ||
this.popup.classList.contains('is-mounted') ||
this.popup.classList.contains('is-opening-prepared')
) &&
this.activeCollection === '1' &&
this.currentViewportWidth() < 769 &&
!(this.drawer && this.drawer.classList.contains('active')) &&
!this.popup.classList.contains('is-items-view')
);
}

clearSupplementFitMode() {
if (this.supplementFitRaf) {
cancelAnimationFrame(this.supplementFitRaf);
this.supplementFitRaf = 0;
}
if (this.popup) {
this.popup.classList.remove(
'is-supplement-fit',
'is-supplement-fit-compact',
'is-supplement-fit-tight',
'is-supplement-scroll-fallback'
);
}
if (this.content) {
this.content.classList.remove('is-supplement-fit-content');
this.content.style.removeProperty('--bb-supplement-stage-height');
}
const wrap = this.querySelector('.ai-bundle-carousel-wrap');
if (wrap) wrap.style.removeProperty('height');
}

fitSupplementViewport() {
/* V75: never stretch the supplement stage to fill the remaining popup height.
   Cards keep their natural content height; overflow is handled separately. */
this.clearSupplementFitMode();
return false;
}

syncContentOverflow() {
if (!this.content || !this.popup.classList.contains('active')) return;

if (this.contentOverflowRaf) {
cancelAnimationFrame(this.contentOverflowRaf);
}

this.contentOverflowRaf = requestAnimationFrame(() => {
this.contentOverflowRaf = 0;

if (!this.content || !this.popup.classList.contains('active')) return;
if (this.drawer && this.drawer.classList.contains('active')) {
this.content.classList.remove('is-scrollable');
return;
}

this.content.classList.remove('is-scrollable');

requestAnimationFrame(() => {
if (!this.content || !this.popup.classList.contains('active')) return;

const needsScroll =
this.content.scrollHeight > this.content.clientHeight + 3;

this.content.classList.toggle('is-scrollable', needsScroll);

if (!needsScroll) {
this.content.scrollTop = 0;
}
});
});
}

scheduleCarouselHeight(force=false) {
if (!this.carousel || !this.popup.classList.contains('active')) return;
if (this.carouselHeightRaf) cancelAnimationFrame(this.carouselHeightRaf);
this.carouselHeightRaf=requestAnimationFrame(()=>{
this.carouselHeightRaf=0;
if (!this.popup.classList.contains('active')) return;
this.measureCarouselHeight(force);
this.syncPodiumGeometry();
this.syncContentOverflow();
});
}
measureCarouselHeight(force=false) {
if (!this.carousel || !this.popup.classList.contains('active')) return;

if (this.isGridCollection()) {
this.carousel.style.height = 'auto';
this.carouselHeightKey = '';
this.carouselHeight = 0;
return;
}

if (this.carouselInteractionLocked) return;

const cards = this.visibleCards();
const active = cards[this.activeIndex];
const width = Math.round(this.carousel.getBoundingClientRect().width);

if (!active || width < 100) return;

/* Measure only the active card. The modal remains fixed-height, while the
   card/dots/meter group closes up smoothly around shorter products. */
const productKey = active.dataset.productId || String(this.activeIndex);
const key = `${width}:${productKey}`;

if (!force && this.carouselHeightKey === key && this.carouselHeight > 0) {
this.carousel.style.height = `${this.carouselHeight}px`;
return;
}

const previousTransition = active.style.getPropertyValue('transition');
const previousVisibility = active.style.getPropertyValue('visibility');
const previousDisplay = active.style.getPropertyValue('display');

active.style.setProperty('display', 'flex', 'important');
active.style.setProperty('visibility', 'hidden', 'important');
active.style.setProperty('transition', 'none', 'important');

const cardHeight = Math.ceil(active.offsetHeight || active.getBoundingClientRect().height);

if (previousDisplay) {
active.style.setProperty('display', previousDisplay);
} else {
active.style.removeProperty('display');
}

if (previousVisibility) {
active.style.setProperty('visibility', previousVisibility);
} else {
active.style.removeProperty('visibility');
}

if (previousTransition) {
active.style.setProperty('transition', previousTransition);
} else {
active.style.removeProperty('transition');
}

if (cardHeight > 0) {
const breathingRoom = 32;
this.carouselHeightKey = key;
this.carouselHeight = cardHeight + breathingRoom;
this.carousel.style.height = `${this.carouselHeight}px`;
}
}
currentVariantId(card) {
const wrapper = card && card.querySelector('.ai-bundle-variants-wrapper');
return wrapper ? String(wrapper.dataset.variantId || '') : '';
}
matchingBundleItems(card) {
if (!card) return [];
const variantId = this.currentVariantId(card);
return this.bundleItems.filter(item =>
String(item.productId) === String(card.dataset.productId) &&
String(item.collectionKey) === String(card.dataset.collection) &&
String(item.variantId) === variantId
);
}
quantityForCard(card) {
return this.matchingBundleItems(card).reduce((sum, item) => sum + Number(item.quantity || 1), 0);
}
setAddButtonLabel(button, label, icon = '＋') {
if (!button) return;
const iconEl = button.querySelector('.ai-bundle-add-icon');
const labelEl = button.querySelector('.ai-bundle-add-label');
if (iconEl && labelEl) {
iconEl.textContent = icon;
iconEl.hidden = !icon;
labelEl.textContent = label;
} else {
button.textContent = (icon ? icon + ' ' : '') + label;
}
}
updateCardAddControl(card) {
if (!card) return;
const wrapper = card.querySelector('.ai-bundle-variants-wrapper');
const addButton = card.querySelector('.ai-bundle-add-btn');
const quantityControl = card.querySelector('.ai-bundle-quantity-control');
if (!wrapper || !addButton) return;
const available = wrapper.dataset.variantAvailable !== 'false';
const isEditingThisCard = Boolean(this.editingUid);
addButton.hidden = false;
addButton.disabled = !available;
if (quantityControl) quantityControl.hidden = true;
if (!addButton.classList.contains('is-added')) {
this.setAddButtonLabel(
addButton,
!available ? 'Sold Out' : (isEditingThisCard ? 'Update bundle item' : 'Add to bundle'),
!available || isEditingThisCard ? '' : '＋'
);
}
}
updateAllCardAddControls() {
this.cards.forEach(card => this.updateCardAddControl(card));
}
flashAddFeedback(button) {
if (!button) return;
const previousTimer = this.addButtonTimers.get(button);
if (previousTimer) window.clearTimeout(previousTimer);
button.classList.add('is-added');
button.disabled = true;
this.setAddButtonLabel(button, 'Added', '✓');
const timer = window.setTimeout(() => {
button.classList.remove('is-added');
this.addButtonTimers.delete(button);
const card = button.closest('.ai-bundle-product-card');
this.updateCardAddControl(card);
}, 560);
this.addButtonTimers.set(button, timer);
}
animateItemCount() {
if (!this.itemCount) return;
window.clearTimeout(this.itemCountAnimationTimer);
this.itemCount.classList.remove('is-count-bumping');
if (this.summaryToggle) this.summaryToggle.classList.remove('is-count-bumping');
void this.itemCount.offsetWidth;
this.itemCount.classList.add('is-count-bumping');
if (this.summaryToggle) this.summaryToggle.classList.add('is-count-bumping');
this.itemCountAnimationTimer = window.setTimeout(() => {
this.itemCount.classList.remove('is-count-bumping');
if (this.summaryToggle) this.summaryToggle.classList.remove('is-count-bumping');
}, 520);
}
addOrUpdate(card, triggerButton = null) {
if (!card) return;
const product = card._bundleProduct;
const wrapper = card.querySelector('.ai-bundle-variants-wrapper');
if (!product || !wrapper) return;
const variant = product.variants.find(v => String(v.id) === String(wrapper.dataset.variantId));
if (!variant || !variant.available) return;
const wasEditing = Boolean(this.editingUid);
const imageEl = card.querySelector('.ai-bundle-product-image');
const editingItem = this.editingUid ? this.bundleItems.find(entry => entry.uid === this.editingUid) : null;
const item = {
uid: this.editingUid || this.uid(),
productId: String(product.id),
collectionKey: card.dataset.collection,
variantId: String(variant.id),
title: card.dataset.displayTitle || product.title,
variantTitle: variant.title === 'Default Title' ? '' : variant.title,
price: Number(variant.price),
image: imageEl ? imageEl.getAttribute('src') : (product.featured_image || ''),
quantity: editingItem ? Number(editingItem.quantity || 1) : 1,
isSupplement: card.dataset.countsSavings === 'true'
};
if (this.editingUid) {
this.bundleItems = this.bundleItems.map(existing => existing.uid === this.editingUid ? item : existing);
this.editingUid = null;
} else {
const existing = this.matchingBundleItems(card)[0];
if (existing) existing.quantity = Number(existing.quantity || 1) + 1;
else this.bundleItems.push(item);
}
this.updateSummary();
this.updateProgress();
this.renderDrawerItems();
this.updateCardButtons();
this.flashAddFeedback(triggerButton || card.querySelector('.ai-bundle-add-btn'));
this.animateItemCount();
}
adjustCardQuantity(card, delta) {
if (!card || !delta) return;
const matches = this.matchingBundleItems(card);
if (delta > 0) {
if (matches.length) {
matches[0].quantity = Number(matches[0].quantity || 1) + delta;
} else {
this.addOrUpdate(card);
return;
}
} else {
const item = matches[0];
if (!item) return;
const nextQuantity = Number(item.quantity || 1) + delta;
if (nextQuantity > 0) item.quantity = nextQuantity;
else this.bundleItems = this.bundleItems.filter(entry => entry.uid !== item.uid);
}
this.updateSummary();
this.updateProgress();
this.renderDrawerItems();
this.updateCardButtons();
this.flashQuantityControl(card);
if (!this.bundleItems.length) this.closeDrawer();
}
editItem(uid) {
const item = this.bundleItems.find(entry => entry.uid === uid);
if (!item) return;
this.editingUid = uid;
if (item.collectionKey !== '1' && item.collectionKey !== '2') {
this.setThirdCollection(item.collectionKey, false);
}
const card = this.cards.find(entry => {
return entry.dataset.collection === item.collectionKey && entry.dataset.productId === String(item.productId);
});
if (card) {
this.activeCollection = item.collectionKey;
this.updateNav();
const cards = this.visibleCards();
this.activeIndex = Math.max(cards.indexOf(card), 0);
this.setVariantOnCard(card, item.variantId);
this.renderCarousel();
this.updateProgress();
if (this.isGridCollection()) {
window.setTimeout(() => {
card.scrollIntoView({ behavior: 'smooth', block: 'center' });
}, 260);
}
}
this.updateCardButtons();
this.closeDrawer();
}
resetCardToFirstVariant(card) {
if (!card) return;

const product = card._bundleProduct;
const wrapper = card.querySelector('.ai-bundle-variants-wrapper');

if (!product || !wrapper || !product.variants || !product.variants.length) return;

const firstAvailable =
product.variants.find(variant => variant && variant.available !== false) ||
product.variants[0];

if (!firstAvailable) return;

wrapper.querySelectorAll('.ai-bundle-chip-row').forEach(row => {
const optionIndex = Number(row.dataset.optionIndex);
const firstValue = firstAvailable['option' + (optionIndex + 1)];

row.querySelectorAll('.ai-bundle-chip').forEach(chip => {
chip.classList.toggle(
'active',
String(chip.dataset.value) === String(firstValue)
);
});
});

this.resolveVariant(card, product);
}

setVariantOnCard(card, variantId) {
const product = card._bundleProduct;
if (!product) return;
const variant = product.variants.find(v => String(v.id) === String(variantId));
if (!variant) return;
const wrapper = card.querySelector('.ai-bundle-variants-wrapper');
wrapper.querySelectorAll('.ai-bundle-chip-row').forEach(row => {
const optionIndex = parseInt(row.dataset.optionIndex);
const value = variant['option' + (optionIndex + 1)];
row.querySelectorAll('.ai-bundle-chip').forEach(chip => {
chip.classList.toggle('active', String(chip.dataset.value) === String(value));
});
});
this.resolveVariant(card, product);
}
updateCardButtons() {
this.updateAllCardAddControls();
}
removeItem(uid) {
this.bundleItems = this.bundleItems.filter(item => item.uid !== uid);
if (this.editingUid === uid) this.editingUid = null;
this.updateSummary();
this.updateProgress();
this.renderDrawerItems();
this.updateCardButtons();
if (!this.bundleItems.length) this.closeDrawer();
}
clearBundle() {
if (!this.bundleItems.length) return;
if (!confirm('Clear your bundle and restart?')) return;
this.bundleItems = [];
this.editingUid = null;
this.updateSummary();
this.updateProgress();
this.renderDrawerItems();
this.closeDrawer();
this.updateCardButtons();
}
updateSummary() {
const totalItems = this.bundleItems.reduce((sum, item) => sum + Number(item.quantity || 1), 0);
const subtotal = this.bundleItems.reduce((sum, item) => sum + (item.price * Number(item.quantity || 1)), 0);
const saving = this.savingAmount();
const bundleTotal = Math.max(subtotal - saving, 0);
this.itemCount.textContent = totalItems;
if (this.itemWord) this.itemWord.textContent = totalItems === 1 ? 'ITEM' : 'ITEMS';
if (this.inBundleLabel) this.inBundleLabel.textContent = 'IN BUNDLE';

if (this.summaryHint) {
this.summaryHint.textContent = '';
this.summaryHint.hidden = true;
this.summaryHint.style.display = 'none';
}

if (this.summaryToggle) {
const itemLabel = totalItems === 1 ? 'item' : 'items';
const drawerOpen = this.drawer && this.drawer.classList.contains('active');
this.summaryToggle.setAttribute(
'aria-label',
`${drawerOpen ? 'Hide' : 'Show'} ${totalItems} ${itemLabel} in bundle`
);
}
this.summaryTotal.textContent = this.money(saving > 0 ? bundleTotal : subtotal);
if (this.savePill) {
const showSaving = saving > 0;
this.savePill.hidden = !showSaving;
this.savePill.style.display = showSaving ? 'inline-flex' : 'none';
this.savePill.innerHTML = showSaving
? '<span class="ai-bundle-save-pill-main">SAVED ' + this.moneyWhole(saving) + '</span><span class="ai-bundle-save-pill-sub">+ FREE DELIVERY</span>'
: '';
}
if (this.summaryOriginal) {
const showOriginal = saving > 0;
this.summaryOriginal.hidden = !showOriginal;
this.summaryOriginal.style.display = showOriginal ? 'inline' : 'none';
this.summaryOriginal.textContent = this.money(subtotal);
}
this.checkoutBtn.disabled = totalItems === 0;
if (this.addCartBtn) this.addCartBtn.disabled = totalItems === 0;
}
updateProgress() {
const count = this.supplementCount();
const capped = Math.min(Math.max(count, 1), this.dealSteps);
const percentage = count <= 1
? 0
: ((capped - 1) / (this.dealSteps - 1)) * 100;
const saving = this.savingAmount();
const previousSaving = this.currentSaving;
const previousCount = this.currentSupplementCount;

let actionMessage = 'ADD 2';
let benefitMessage = 'SAVE R 100 + FREE SHIPPING';

if (count === 1) {
actionMessage = 'ADD 1 MORE';
benefitMessage = 'SAVE R 100 + FREE SHIPPING';
} else if (count === 2) {
actionMessage = 'ADD 1 MORE';
benefitMessage = 'SAVE R 200 + FREE SHIPPING';
} else if (count === 3) {
actionMessage = 'ADD 1 MORE';
benefitMessage = 'SAVE R 300 + FREE SHIPPING';
} else if (count >= 4) {
actionMessage = 'MAX SAVING';
benefitMessage = 'R 300 OFF + FREE SHIPPING';
}

this.progressBar.style.width = percentage + '%';
this.progressEyebrow.textContent = actionMessage;
this.progressTitle.textContent = benefitMessage;

this.progressSections.forEach(section => {
section.classList.toggle('is-unlocked', count >= 2);
section.classList.toggle('is-best', count >= 4);
});

const milestoneNumbers = this.dealStepEls
.map(step => Number(step.dataset.meterStep))
.filter(Number.isFinite)
.sort((a, b) => a - b);

const nextMilestone = milestoneNumbers.find(stepNumber => stepNumber > count) || null;

this.dealStepEls.forEach(step => {
const stepNumber = Number(step.dataset.meterStep);
const reached = count >= stepNumber;
const isBenefitMilestone = stepNumber >= 2;
const isNext = !reached && stepNumber === nextMilestone;
const isCurrent = count === stepNumber || (stepNumber === 4 && count >= 4);
const dot = step.querySelector('.ai-bundle-meter__dot');

step.classList.toggle('active', reached);
step.classList.toggle('unlocked', reached);
step.classList.toggle('benefit-unlocked', reached && isBenefitMilestone);
step.classList.toggle('next', isNext);
step.classList.toggle('current', isCurrent);

if (dot) {
dot.textContent = reached && isBenefitMilestone ? '✓' : String(stepNumber);
}
});

this.progressSections.forEach(section => {
section.classList.toggle('show-note', !this.activeCollectionCountsTowardSavings());
section.classList.toggle('is-hidden-by-collection', this.shouldHideProgressBar());
});

if (this.footer) {
this.footer.classList.toggle('is-addons-view', this.activeCollection === '2');
}
if (this.popup) {
this.popup.classList.toggle('is-addons-view', this.activeCollection === '2');
}

if (saving > previousSaving) {
this.animateReward(capped);
}

const finalStep = this.dealStepEls.find(step => Number(step.dataset.meterStep) === 4);
if (finalStep) {
finalStep.classList.toggle('final-success', count >= 4);
if (count >= 4 && previousCount < 4) {
this.animateFinalMilestone(finalStep);
}
}

this.currentSaving = saving;
this.currentSupplementCount = count;
this.updateSummary();
}
animateFinalMilestone(step) {
if (!step) return;
window.clearTimeout(this.finalMilestoneTimer);
step.classList.remove('final-success-burst');
void step.offsetWidth;
step.classList.add('final-success-burst');
this.finalMilestoneTimer = window.setTimeout(() => {
step.classList.remove('final-success-burst');
}, 1100);
}
animateReward(stepNumber) {
this.progressEyebrow.classList.remove('reward-pop');
void this.progressEyebrow.offsetWidth;
this.progressEyebrow.classList.add('reward-pop');
const targetStep = this.dealStepEls.find(step => Number(step.dataset.meterStep) === stepNumber);
if (targetStep) {
targetStep.classList.remove('reward-burst');
void targetStep.offsetWidth;
targetStep.classList.add('reward-burst');
}
if (this.savePill && !this.savePill.hidden) {
this.savePill.classList.remove('reward-pop');
void this.savePill.offsetWidth;
this.savePill.classList.add('reward-pop');
}
window.setTimeout(() => {
this.progressEyebrow.classList.remove('reward-pop');
if (targetStep) targetStep.classList.remove('reward-burst');
if (this.savePill) this.savePill.classList.remove('reward-pop');
}, 800);
}
toggleDrawer() {
if (!this.bundleItems.length || !this.popup.classList.contains('active')) return;

if (this.drawer.classList.contains('active')) {
this.closeDrawer();
return;
}

this.renderDrawerItems();
this.cancelCarouselGesture();

this.drawer.classList.add('active');
this.drawer.setAttribute('aria-hidden', 'false');

/* V118: Items view is its own clean internal screen.
   Temporarily remove Add-ons layout mode so both view systems never compete. */
this.itemsOpenedFromAddons =
this.popup.classList.contains('is-addons-view') ||
this.activeCollection === '2';

this.popup.classList.remove('is-addons-view');
if (this.footer) this.footer.classList.remove('is-addons-view');

this.popup.classList.add('is-items-view');
this.clearSupplementFitMode();

if (this.content) {
this.content.setAttribute('aria-hidden', 'true');
}

if (this.summaryArrow) this.summaryArrow.classList.add('is-open');
if (this.summaryToggle) {
this.summaryToggle.setAttribute('aria-expanded', 'true');
const totalItems = this.bundleItems.reduce(
(sum, item) => sum + Number(item.quantity || 1),
0
);
const itemLabel = totalItems === 1 ? 'item' : 'items';
this.summaryToggle.setAttribute(
'aria-label',
`Hide ${totalItems} ${itemLabel} in bundle`
);
}
if (this.summaryHint) {
this.summaryHint.textContent = '';
this.summaryHint.hidden = true;
this.summaryHint.style.display = 'none';
}

this.drawer.scrollTop = 0;
if (this.drawerItems) this.drawerItems.scrollTop = 0;

requestAnimationFrame(() => {
if (this.drawerClose) {
this.drawerClose.focus({ preventScroll: true });
}
});
}

closeDrawer(options = {}) {
if (!this.drawer) return;

this.drawer.classList.remove('active');
this.drawer.setAttribute('aria-hidden', 'true');
this.popup.classList.remove('is-items-view');

/* Restore the collection layout the user came from. */
const restoreAddonsView = this.activeCollection === '2';
this.popup.classList.toggle('is-addons-view', restoreAddonsView);
if (this.footer) {
this.footer.classList.toggle('is-addons-view', restoreAddonsView);
}
this.itemsOpenedFromAddons = false;

if (this.content) {
this.content.removeAttribute('aria-hidden');
}

if (this.summaryArrow) this.summaryArrow.classList.remove('is-open');
if (this.summaryToggle) {
this.summaryToggle.setAttribute('aria-expanded', 'false');
const totalItems = this.bundleItems.reduce(
(sum, item) => sum + Number(item.quantity || 1),
0
);
const itemLabel = totalItems === 1 ? 'item' : 'items';
this.summaryToggle.setAttribute(
'aria-label',
`Show ${totalItems} ${itemLabel} in bundle`
);
}
if (this.summaryHint) {
this.summaryHint.textContent = '';
this.summaryHint.hidden = true;
this.summaryHint.style.display = 'none';
}

if (!options.immediate && this.popup.classList.contains('active')) {
requestAnimationFrame(() => {
this.scheduleCarouselHeight(true);
this.syncContentOverflow();
});
}
}

renderDrawerItems() {
if (!this.drawerItems) return;

if (!this.bundleItems.length) {
this.drawerItems.innerHTML = '<p class="ai-bundle-drawer-empty">No items in bundle yet</p>';
return;
}

this.drawerItems.innerHTML = this.bundleItems.map(item => `
<div class="ai-bundle-drawer-item">
${item.image ? `<img class="ai-bundle-drawer-thumb" src="${item.image}" alt="">` : ''}
<div class="ai-bundle-drawer-info">
<div class="ai-bundle-drawer-item-title">${this.escape(item.title)}</div>
<div class="ai-bundle-drawer-item-details">${this.escape(item.variantTitle || 'Selected')} · Qty ${Number(item.quantity || 1)} · ${item.isSupplement ? 'Supplement' : 'Extra'} · ${this.money(item.price)} each</div>
</div>
<div class="ai-bundle-drawer-actions">
<button class="ai-bundle-drawer-action" data-edit="${item.uid}" type="button">Edit</button>
<button class="ai-bundle-drawer-action ai-bundle-drawer-remove" data-remove="${item.uid}" type="button">Remove</button>
</div>
</div>
`).join('') + '<div class="ai-bundle-items-actions" role="group" aria-label="Bundle item actions"><button class="ai-bundle-drawer-clear ai-bundle-drawer-clear-after-items" data-clear-bundle type="button">Clear all items</button><button class="ai-bundle-back-to-builder" data-back-to-builder type="button">Back to builder</button></div>';

this.drawerItems.querySelectorAll('[data-edit]').forEach(btn => {
btn.addEventListener('click', () => this.editItem(btn.dataset.edit));
});

this.drawerItems.querySelectorAll('[data-remove]').forEach(btn => {
btn.addEventListener('click', () => this.removeItem(btn.dataset.remove));
});

const clearButton = this.drawerItems.querySelector('[data-clear-bundle]');
if (clearButton) {
clearButton.addEventListener('click', () => this.clearBundle());
}

const backButton = this.drawerItems.querySelector('[data-back-to-builder]');
if (backButton) {
backButton.addEventListener('click', () => {
this.closeDrawer();
requestAnimationFrame(() => {
if (this.summaryToggle) this.summaryToggle.focus({ preventScroll: true });
});
});
}
}

installThemeCartDrawerBridge() {
if (window.__camelusCartDrawerBridgeInstalled) return;
window.__camelusCartDrawerBridgeInstalled = true;
document.addEventListener('theme:cart:popdown', function () {
window.__cartDrawerShouldInstantUpdate = true;
if (window.__camelusOpenDrawerAfterCartUpdate) {
document.removeEventListener('theme:cart:change', window.__camelusOpenDrawerAfterCartUpdate);
}
const openDrawerAfterCartUpdate = function () {
const drawer = document.querySelector('[data-drawer="drawer-cart"]');
if (drawer) {
drawer.dispatchEvent(
new CustomEvent('theme:drawer:open', {
bubbles: false
})
);
}
document.removeEventListener('theme:cart:change', openDrawerAfterCartUpdate);
if (window.__camelusOpenDrawerAfterCartUpdate === openDrawerAfterCartUpdate) {
window.__camelusOpenDrawerAfterCartUpdate = null;
}
};
window.__camelusOpenDrawerAfterCartUpdate = openDrawerAfterCartUpdate;
document.addEventListener('theme:cart:change', openDrawerAfterCartUpdate);
});
}
shopRoute(path) {
const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
? window.Shopify.routes.root
: '/';
return root.replace(/\/?$/, '/') + String(path || '').replace(/^\/+/, '');
}
bundleCartPayload() {
const quantities = {};
this.bundleItems.forEach(item => {
const id = String(item.variantId);
quantities[id] = (quantities[id] || 0) + Number(item.quantity || 1);
});
return {
items: Object.entries(quantities).map(([id, quantity]) => ({
id: Number(id),
quantity,
properties: {
_camelus_bundle: 'Build Your Bundle'
}
}))
};
}
bundleActionButtons() {
return [
this.checkoutBtn,
this.addCartBtn
].filter(Boolean);
}
async submitBundle(mode = 'checkout', triggerButton = null) {
if (!this.bundleItems.length || this.cartRequestInFlight) return;
this.cartRequestInFlight = true;
const actionButtons = this.bundleActionButtons();
const originalStates = actionButtons.map(button => ({
button,
html: button.innerHTML,
disabled: button.disabled
}));
let redirectingToCheckout = false;
actionButtons.forEach(button => {
button.disabled = true;
button.setAttribute('aria-busy', 'true');
});
const activeButton = triggerButton || this.checkoutBtn;
if (activeButton) {
activeButton.innerHTML = mode === 'checkout'
? '<span>Preparing checkout...</span><span class="ai-bundle-checkout-spinner" aria-hidden="true"></span>'
: '<span>Adding to cart...</span><span class="ai-bundle-checkout-spinner" aria-hidden="true"></span>';
}
try {
const addResponse = await fetch(this.shopRoute('cart/add.js'), {
method: 'POST',
credentials: 'same-origin',
headers: {
'Content-Type': 'application/json',
'Accept': 'application/json'
},
body: JSON.stringify(this.bundleCartPayload())
});
if (!addResponse.ok) {
let message = 'Something went wrong adding your bundle.';
try {
const errorData = await addResponse.json();
if (errorData && errorData.description) message = errorData.description;
} catch (error) {}
throw new Error(message);
}
const cartResponse = await fetch(this.shopRoute('cart.js'), {
method: 'GET',
credentials: 'same-origin',
headers: { 'Accept': 'application/json' },
cache: 'no-store'
});
if (!cartResponse.ok) throw new Error('The cart could not be refreshed.');
const cart = await cartResponse.json();
document.dispatchEvent(
new CustomEvent('theme:cart:change', {
detail: { cart },
bubbles: true
})
);
if (mode === 'checkout') {
redirectingToCheckout = true;
window.location.assign(this.shopRoute('checkout'));
return;
}
if (activeButton) activeButton.innerHTML = '<span>Added to cart ✓</span>';
await new Promise(resolve => window.setTimeout(resolve, 160));
this.closePopup();
} catch (error) {
console.error('Camelus bundle cart error:', error);
alert(error.message || 'Something went wrong adding your bundle. Please try again.');
} finally {
if (!redirectingToCheckout) {
originalStates.forEach(({ button, html, disabled }) => {
if (!button || !button.isConnected) return;
button.innerHTML = html;
button.disabled = disabled;
button.removeAttribute('aria-busy');
});
this.checkoutBtn.disabled = this.bundleItems.length === 0;
if (this.addCartBtn) this.addCartBtn.disabled = this.bundleItems.length === 0;
this.cartRequestInFlight = false;
}
}
}
money(cents) {
return 'R ' + (Number(cents || 0) / 100).toFixed(2);
}
moneyWhole(cents) {
return 'R ' + Math.round(Number(cents || 0) / 100);
}
escape(value) {
return String(value || '').replace(/[&<>"']/g, char => ({
'&': '&amp;',
'<': '&lt;',
'>': '&gt;',
'"': '&quot;',
"'": '&#039;'
})[char]);
}
}
if (!customElements.get('bundle-builder')) {
customElements.define('bundle-builder', BundleBuilder);
}
})();

/* === Premium swipe V4: tap-safe variants + cleaner peeks === */